import { SvelteStyleStoreFactory, StyleUtilities } from '@collectivehealth/dls-styles';
import '@collectivehealth/dls-button';
import '@collectivehealth/dls-button/dist/button-theme-transparent.es.js';
import '@collectivehealth/dls-icons/dist/es/elements/dls-icon-chevron-down.js';

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _CustomElement() {
  return Reflect.construct(HTMLElement, [], this.__proto__.constructor);
}

Object.setPrototypeOf(_CustomElement.prototype, HTMLElement.prototype);
Object.setPrototypeOf(_CustomElement, HTMLElement);

function noop() {}

function run(fn) {
  return fn();
}

function blank_object() {
  return Object.create(null);
}

function run_all(fns) {
  fns.forEach(run);
}

function is_function(thing) {
  return typeof thing === 'function';
}

function safe_not_equal(a, b) {
  return a != a ? b == b : a !== b || a && _typeof(a) === 'object' || typeof a === 'function';
}

function subscribe(store) {
  for (var _len = arguments.length, callbacks = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    callbacks[_key - 1] = arguments[_key];
  }

  var unsub = store.subscribe.apply(store, callbacks);
  return unsub.unsubscribe ? function () {
    return unsub.unsubscribe();
  } : unsub;
}

function component_subscribe(component, store, callback) {
  component.$$.on_destroy.push(subscribe(store, callback));
}

function action_destroyer(action_result) {
  return action_result && is_function(action_result.destroy) ? action_result.destroy : noop;
}

function append(target, node) {
  target.appendChild(node);
}

function insert(target, node, anchor) {
  target.insertBefore(node, anchor || null);
}

function detach(node) {
  node.parentNode.removeChild(node);
}

function element(name) {
  return document.createElement(name);
}

function text(data) {
  return document.createTextNode(data);
}

function space() {
  return text(' ');
}

function empty() {
  return text('');
}

function listen(node, event, handler, options) {
  node.addEventListener(event, handler, options);
  return function () {
    return node.removeEventListener(event, handler, options);
  };
}

function attr(node, attribute, value) {
  if (value == null) node.removeAttribute(attribute);else if (node.getAttribute(attribute) !== value) node.setAttribute(attribute, value);
}

function set_custom_element_data(node, prop, value) {
  if (prop in node) {
    node[prop] = value;
  } else {
    attr(node, prop, value);
  }
}

function children(element) {
  return Array.from(element.childNodes);
}

function set_data(text, data) {
  data = '' + data;
  if (text.data !== data) text.data = data;
}

var HtmlTag =
/*#__PURE__*/
function () {
  function HtmlTag(html) {
    var anchor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    _classCallCheck(this, HtmlTag);

    this.e = element('div');
    this.a = anchor;
    this.u(html);
  }

  _createClass(HtmlTag, [{
    key: "m",
    value: function m(target) {
      var anchor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      for (var i = 0; i < this.n.length; i += 1) {
        insert(target, this.n[i], anchor);
      }

      this.t = target;
    }
  }, {
    key: "u",
    value: function u(html) {
      this.e.innerHTML = html;
      this.n = Array.from(this.e.childNodes);
    }
  }, {
    key: "p",
    value: function p(html) {
      this.d();
      this.u(html);
      this.m(this.t, this.a);
    }
  }, {
    key: "d",
    value: function d() {
      this.n.forEach(detach);
    }
  }]);

  return HtmlTag;
}();

var current_component;

function set_current_component(component) {
  current_component = component;
}

var dirty_components = [];
var binding_callbacks = [];
var render_callbacks = [];
var flush_callbacks = [];
var resolved_promise = Promise.resolve();
var update_scheduled = false;

function schedule_update() {
  if (!update_scheduled) {
    update_scheduled = true;
    resolved_promise.then(flush);
  }
}

function add_render_callback(fn) {
  render_callbacks.push(fn);
}

function flush() {
  var seen_callbacks = new Set();

  do {
    // first, call beforeUpdate functions
    // and update components
    while (dirty_components.length) {
      var component = dirty_components.shift();
      set_current_component(component);
      update(component.$$);
    }

    while (binding_callbacks.length) {
      binding_callbacks.pop()();
    } // then, once components are updated, call
    // afterUpdate functions. This may cause
    // subsequent updates...


    for (var i = 0; i < render_callbacks.length; i += 1) {
      var callback = render_callbacks[i];

      if (!seen_callbacks.has(callback)) {
        callback(); // ...so guard against infinite loops

        seen_callbacks.add(callback);
      }
    }

    render_callbacks.length = 0;
  } while (dirty_components.length);

  while (flush_callbacks.length) {
    flush_callbacks.pop()();
  }

  update_scheduled = false;
}

function update($$) {
  if ($$.fragment !== null) {
    $$.update();
    run_all($$.before_update);
    var dirty = $$.dirty;
    $$.dirty = [-1];
    $$.fragment && $$.fragment.p($$.ctx, dirty);
    $$.after_update.forEach(add_render_callback);
  }
}

var outroing = new Set();

function transition_in(block, local) {
  if (block && block.i) {
    outroing.delete(block);
    block.i(local);
  }
}

var globals = typeof window !== 'undefined' ? window : global;

function mount_component(component, target, anchor) {
  var _component$$$ = component.$$,
      fragment = _component$$$.fragment,
      on_mount = _component$$$.on_mount,
      on_destroy = _component$$$.on_destroy,
      after_update = _component$$$.after_update;
  fragment && fragment.m(target, anchor); // onMount happens before the initial afterUpdate

  add_render_callback(function () {
    var new_on_destroy = on_mount.map(run).filter(is_function);

    if (on_destroy) {
      on_destroy.push.apply(on_destroy, _toConsumableArray(new_on_destroy));
    } else {
      // Edge case - component was destroyed immediately,
      // most likely as a result of a binding initialising
      run_all(new_on_destroy);
    }

    component.$$.on_mount = [];
  });
  after_update.forEach(add_render_callback);
}

function destroy_component(component, detaching) {
  var $$ = component.$$;

  if ($$.fragment !== null) {
    run_all($$.on_destroy);
    $$.fragment && $$.fragment.d(detaching); // TODO null out other refs, including component.$$ (but need to
    // preserve final state?)

    $$.on_destroy = $$.fragment = null;
    $$.ctx = [];
  }
}

function make_dirty(component, i) {
  if (component.$$.dirty[0] === -1) {
    dirty_components.push(component);
    schedule_update();
    component.$$.dirty.fill(0);
  }

  component.$$.dirty[i / 31 | 0] |= 1 << i % 31;
}

function init(component, options, instance, create_fragment, not_equal, props) {
  var dirty = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [-1];
  var parent_component = current_component;
  set_current_component(component);
  var prop_values = options.props || {};
  var $$ = component.$$ = {
    fragment: null,
    ctx: null,
    // state
    props: props,
    update: noop,
    not_equal: not_equal,
    bound: blank_object(),
    // lifecycle
    on_mount: [],
    on_destroy: [],
    before_update: [],
    after_update: [],
    context: new Map(parent_component ? parent_component.$$.context : []),
    // everything else
    callbacks: blank_object(),
    dirty: dirty
  };
  var ready = false;
  $$.ctx = instance ? instance(component, prop_values, function (i, ret) {
    var value = (arguments.length <= 2 ? 0 : arguments.length - 2) ? arguments.length <= 2 ? undefined : arguments[2] : ret;

    if ($$.ctx && not_equal($$.ctx[i], $$.ctx[i] = value)) {
      if ($$.bound[i]) $$.bound[i](value);
      if (ready) make_dirty(component, i);
    }

    return ret;
  }) : [];
  $$.update();
  ready = true;
  run_all($$.before_update); // `false` as a special case of no DOM component

  $$.fragment = create_fragment ? create_fragment($$.ctx) : false;

  if (options.target) {
    if (options.hydrate) {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      $$.fragment && $$.fragment.l(children(options.target));
    } else {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      $$.fragment && $$.fragment.c();
    }

    if (options.intro) transition_in(component.$$.fragment);
    mount_component(component, options.target, options.anchor);
    flush();
  }

  set_current_component(parent_component);
}

var SvelteElement;

if (typeof HTMLElement === 'function') {
  SvelteElement =
  /*#__PURE__*/
  function (_CustomElement2) {
    _inherits(SvelteElement, _CustomElement2);

    function SvelteElement() {
      var _this;

      _classCallCheck(this, SvelteElement);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(SvelteElement).call(this));

      _this.attachShadow({
        mode: 'open'
      });

      return _this;
    }

    _createClass(SvelteElement, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        // @ts-ignore todo: improve typings
        for (var key in this.$$.slotted) {
          // @ts-ignore todo: improve typings
          this.appendChild(this.$$.slotted[key]);
        }
      }
    }, {
      key: "attributeChangedCallback",
      value: function attributeChangedCallback(attr, _oldValue, newValue) {
        this[attr] = newValue;
      }
    }, {
      key: "$destroy",
      value: function $destroy() {
        destroy_component(this, 1);
        this.$destroy = noop;
      }
    }, {
      key: "$on",
      value: function $on(type, callback) {
        // TODO should this delegate to addEventListener?
        var callbacks = this.$$.callbacks[type] || (this.$$.callbacks[type] = []);
        callbacks.push(callback);
        return function () {
          var index = callbacks.indexOf(callback);
          if (index !== -1) callbacks.splice(index, 1);
        };
      }
    }, {
      key: "$set",
      value: function $set() {// overridden by instance, if it has props
      }
    }]);

    return SvelteElement;
  }(_CustomElement);
}

(function polyfillClosest() {
  /* closest() polyfill */
  if (typeof window.Element.prototype.closest !== 'function') {
    if (window.Element.prototype.matches !== 'function') {
      window.Element.prototype.matches = window.Element.prototype.msMatchesSelector;
    }
    /* for IE11 */


    window.Element.prototype.closest = function closest(selector) {
      var element = this;

      while (element && element.nodeType === 1) {
        if (element.matches(selector)) {
          return element;
        }

        element = element.parentNode;
      }

      return null;
    };
  }
})();

function noop$1() {// no operation
}

function dispatchChangeEvent(element, _labellist, _valuelist, label, value) {
  if (!element) {
    return;
  }

  element.dispatchEvent(new CustomEvent('dlslistchange', {
    bubbles: true,
    composed: true,
    detail: {
      _labellist: _labellist,
      _valuelist: _valuelist,
      label: label,
      value: value
    }
  }));
} // TODO: we check for text in slotted nodes in 3 different ways:
// innerText, textContent, and nodeValue


function getSlotChangeHandler() {
  var onBeforeHandle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : noop$1;
  var onAfterHandle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop$1;
  var filterNodes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (node) {
    // Element or non-empty text node
    return node.nodeType === Node.TEXT_NODE && node.nodeValue.trim().length || node.nodeType === Node.ELEMENT_NODE;
  };
  return function getSlottedChildren(event) {
    onBeforeHandle(event);
    var slottedChildren = event.target.assignedNodes({
      flatten: true
    }).filter(filterNodes);
    onAfterHandle(event, slottedChildren);
  };
}

function getInputDispatcher(hostElement, normalizedTriggerLabel, value) {
  return function dispatchInputEvent() {
    if (!hostElement) {
      return;
    }

    hostElement.dispatchEvent(new CustomEvent('dlslistiteminput', {
      bubbles: true,
      composed: false,
      detail: {
        label: normalizedTriggerLabel,
        value: value
      }
    }));
  };
}

function registerAutoCloseListener(open, autoclose, handler) {
  if (autoclose) {
    var command = "".concat(open ? 'add' : 'remove', "EventListener");
    document[command]('click', handler);
  }
}

function updateItemSelections(slottedChildren, _valuelist) {
  slottedChildren.forEach(function (child) {
    if (Array.isArray(child._valuelist)) {
      child._valuelist = _valuelist;
    }
  });
}

function getUpdateItemSelection(hostElement) {
  return function updateSelection(_valuelist, valueOrLabel) {
    if (!hostElement) {
      return;
    }

    if (_valuelist.indexOf(valueOrLabel) === -1) {
      hostElement.removeAttribute('selected');
    } else {
      hostElement.setAttribute('selected', 'selected');
    }
  };
}

function updateSelectedList(_labellist, _valuelist, label, value, multiple, toggleable) {
  var changed = false;

  if (multiple) {
    // multiple implies toggleable
    if (_valuelist.indexOf(value) !== -1) {
      _valuelist = _valuelist.filter(function (v) {
        return v !== value;
      });
      _labellist = _labellist.filter(function (v) {
        return v !== label;
      });
      changed = true;
    } else {
      _valuelist = [].concat(_valuelist, value);
      _labellist = [].concat(_labellist, label);
      changed = true;
    }
  } else if (_valuelist.indexOf(value) === -1) {
    _valuelist = [value];
    _labellist = [label];
    changed = true;
  } else if (toggleable) {
    _valuelist = [];
    _labellist = [];
    changed = true;
  } else {
    changed = false;
  }

  return {
    _labellist: _labellist,
    _valuelist: _valuelist,
    changed: changed
  };
}

var dropdown = {
  "dropdown": "mcca338abf_dropdown",
  "dropdownMenu": "mcca338abf_dropdownMenu",
  "_dropdownInner": "mcca338abf__dropdownInner",
  "top": "mcca338abf_top",
  "_dropdownTriggerSlot": "mcca338abf__dropdownTriggerSlot",
  "_dropdownMenuWrapper": "mcca338abf__dropdownMenuWrapper",
  "open": "mcca338abf_open",
  "wrapMenu": "mcca338abf_wrapMenu",
  "noscroll": "mcca338abf_noscroll",
  "left": "mcca338abf_left",
  "right": "mcca338abf_right",
  "bottom": "mcca338abf_bottom"
};
var dropdown$1 = "mcca338abf_dropdown";
var dropdownMenu = "mcca338abf_dropdownMenu";
var _dropdownInner = "mcca338abf__dropdownInner";
var top = "mcca338abf_top";
var _dropdownTriggerSlot = "mcca338abf__dropdownTriggerSlot";
var _dropdownMenuWrapper = "mcca338abf__dropdownMenuWrapper";
var open = "mcca338abf_open";
var wrapMenu = "mcca338abf_wrapMenu";
var noscroll = "mcca338abf_noscroll";
var left = "mcca338abf_left";
var right = "mcca338abf_right";
var bottom = "mcca338abf_bottom";
var styles = ".mcca338abf_dropdown .mcca338abf_dropdownMenu{outline:0}.mcca338abf__dropdownInner{display:flex;flex-direction:column}.mcca338abf__dropdownInner.mcca338abf_top{flex-direction:column-reverse}.mcca338abf__dropdownMenuWrapper{display:none;position:relative}.mcca338abf__dropdownMenuWrapper.mcca338abf_open{display:block}.mcca338abf_dropdownMenu{background:#fff;border-radius:2px;box-shadow:0 2px 8px 0 rgba(0,0,0,.24);max-height:324px;min-width:100%;overflow-x:hidden;overflow-y:auto;position:absolute;white-space:nowrap;width:auto;z-index:1}.mcca338abf_dropdownMenu.mcca338abf_wrapMenu{white-space:normal}.mcca338abf_dropdownMenu:after,.mcca338abf_dropdownMenu:before{content:\"\";display:block;flex:1 0 auto;height:12px}.mcca338abf_dropdownMenu.mcca338abf_noscroll{max-height:none}.mcca338abf_dropdownMenu.mcca338abf_left{left:0}.mcca338abf_dropdownMenu.mcca338abf_right{right:0}.mcca338abf_bottom .mcca338abf_dropdownMenu{top:0;margin-top:8px}.mcca338abf_top .mcca338abf_dropdownMenu{bottom:0;margin-bottom:8px}[data-style]{display:none}";
var dropdownStyles =
/*#__PURE__*/
Object.freeze({
  __proto__: null,
  'default': dropdown,
  dropdown: dropdown$1,
  dropdownMenu: dropdownMenu,
  _dropdownInner: _dropdownInner,
  top: top,
  _dropdownTriggerSlot: _dropdownTriggerSlot,
  _dropdownMenuWrapper: _dropdownMenuWrapper,
  open: open,
  wrapMenu: wrapMenu,
  noscroll: noscroll,
  left: left,
  right: right,
  bottom: bottom,
  styles: styles
});
var dropdownStyleStore = SvelteStyleStoreFactory();
var subscribe$1 = dropdownStyleStore.subscribe,
    addStyles = dropdownStyleStore.addStyles;
var document_1 = globals.document;

function create_if_block_1(ctx) {
  var html_tag;
  return {
    c: function c() {
      html_tag = new HtmlTag(
      /*polyfillStyleTags*/
      ctx[9], null);
    },
    m: function m(target, anchor) {
      html_tag.m(target, anchor);
    },
    p: function p(ctx, dirty) {
      if (dirty[0] &
      /*polyfillStyleTags*/
      512) html_tag.p(
      /*polyfillStyleTags*/
      ctx[9]);
    },
    d: function d(detaching) {
      if (detaching) html_tag.d();
    }
  };
} // (11:0) {#if !style.usesPolyfill}


function create_if_block(ctx) {
  var div0;
  var t;
  var div1;
  var raw1_value =
  /*$altStyles*/
  ctx[8].sheet("theme/".concat(
  /*theme*/
  ctx[5])) + "";
  return {
    c: function c() {
      div0 = element("div");
      t = space();
      div1 = element("div");
      attr(div0, "data-style", "");
      attr(div1, "data-style", "");
    },
    m: function m(target, anchor) {
      insert(target, div0, anchor);
      div0.innerHTML =
      /*stylesheet*/
      ctx[11];
      insert(target, t, anchor);
      insert(target, div1, anchor);
      div1.innerHTML = raw1_value;
    },
    p: function p(ctx, dirty) {
      if (dirty[0] &
      /*$altStyles, theme*/
      288 && raw1_value !== (raw1_value =
      /*$altStyles*/
      ctx[8].sheet("theme/".concat(
      /*theme*/
      ctx[5])) + "")) div1.innerHTML = raw1_value;
    },
    d: function d(detaching) {
      if (detaching) detach(div0);
      if (detaching) detach(t);
      if (detaching) detach(div1);
    }
  };
}

function create_fragment(ctx) {
  var if_block0_anchor;
  var t0;
  var t1;
  var div4;
  var div3;
  var div0;
  var slot0;
  var div0_class_value;
  var t2;
  var div2;
  var div1;
  var slot1;
  var t3;
  var slot2;
  var div1_class_value;
  var div2_class_value;
  var div3_class_value;
  var div4_class_value;
  var initialize_action;
  var dispose;
  var if_block0 =
  /*style*/
  ctx[12].usesPolyfill && create_if_block_1(ctx);
  var if_block1 = !
  /*style*/
  ctx[12].usesPolyfill && create_if_block(ctx);
  return {
    c: function c() {
      if (if_block0) if_block0.c();
      if_block0_anchor = empty();
      t0 = space();
      if (if_block1) if_block1.c();
      t1 = space();
      div4 = element("div");
      div3 = element("div");
      div0 = element("div");
      slot0 = element("slot");
      t2 = space();
      div2 = element("div");
      div1 = element("div");
      slot1 = element("slot");
      t3 = space();
      slot2 = element("slot");
      this.c = noop;
      attr(slot0, "name", "dropdown-trigger");
      attr(div0, "class", div0_class_value =
      /*style*/
      ctx[12].is("_dropdownTriggerSlot"));
      attr(slot1, "name", "dropdown-menu");
      attr(div1, "class", div1_class_value = "" + (
      /*style*/
      ctx[12].are("dropdownMenu",
      /*align*/
      ctx[0]) + " " +
      /*style*/
      ctx[12].if("noscroll",
      /*noscroll*/
      ctx[4]) + " " +
      /*style*/
      ctx[12].if("wrapMenu",
      /*wrapmenu*/
      ctx[6]) + " " +
      /*$altStyles*/
      ctx[8].part("theme/".concat(
      /*theme*/
      ctx[5], "/dropdownMenu")) + " " +
      /*themeVariants*/
      ctx[10]));
      attr(div1, "tabindex", "-1");
      attr(div2, "class", div2_class_value = "" + (
      /*style*/
      ctx[12].is("_dropdownMenuWrapper") + " " +
      /*style*/
      ctx[12].if("open",
      /*open*/
      ctx[1])));
      attr(div3, "class", div3_class_value = "" + (
      /*style*/
      ctx[12].are("_dropdownInner",
      /*position*/
      ctx[2]) + " " +
      /*style*/
      ctx[12].if("disabled",
      /*disabled*/
      ctx[3]) + " " +
      /*themeVariants*/
      ctx[10]));
      attr(div4, "class", div4_class_value = "" + (
      /*style*/
      ctx[12].is("dropdown") + " " +
      /*$altStyles*/
      ctx[8].part("theme/".concat(
      /*theme*/
      ctx[5], "/dropdown")) + " " +
      /*themeVariants*/
      ctx[10]));
      attr(div4, "tabindex", "-1");
    },
    m: function m(target, anchor) {
      if (if_block0) if_block0.m(document_1.head, null);
      append(document_1.head, if_block0_anchor);
      insert(target, t0, anchor);
      if (if_block1) if_block1.m(target, anchor);
      insert(target, t1, anchor);
      insert(target, div4, anchor);
      append(div4, div3);
      append(div3, div0);
      append(div0, slot0);
      append(div3, t2);
      append(div3, div2);
      append(div2, div1);
      append(div1, slot1);
      append(div1, t3);
      append(div1, slot2);
      /*div1_binding*/

      ctx[40](div1);
      dispose = [listen(slot0, "slotchange",
      /*getSlottedTriggers*/
      ctx[15]), listen(slot1, "slotchange",
      /*getSlottedChildren*/
      ctx[14]), listen(slot2, "slotchange",
      /*getSlottedChildren*/
      ctx[14]), action_destroyer(initialize_action =
      /*initialize*/
      ctx[13].call(null, div4))];
    },
    p: function p(ctx, dirty) {
      if (
      /*style*/
      ctx[12].usesPolyfill) if_block0.p(ctx, dirty);
      if (!
      /*style*/
      ctx[12].usesPolyfill) if_block1.p(ctx, dirty);

      if (dirty[0] &
      /*align, noscroll, wrapmenu, $altStyles, theme, themeVariants*/
      1393 && div1_class_value !== (div1_class_value = "" + (
      /*style*/
      ctx[12].are("dropdownMenu",
      /*align*/
      ctx[0]) + " " +
      /*style*/
      ctx[12].if("noscroll",
      /*noscroll*/
      ctx[4]) + " " +
      /*style*/
      ctx[12].if("wrapMenu",
      /*wrapmenu*/
      ctx[6]) + " " +
      /*$altStyles*/
      ctx[8].part("theme/".concat(
      /*theme*/
      ctx[5], "/dropdownMenu")) + " " +
      /*themeVariants*/
      ctx[10]))) {
        attr(div1, "class", div1_class_value);
      }

      if (dirty[0] &
      /*open*/
      2 && div2_class_value !== (div2_class_value = "" + (
      /*style*/
      ctx[12].is("_dropdownMenuWrapper") + " " +
      /*style*/
      ctx[12].if("open",
      /*open*/
      ctx[1])))) {
        attr(div2, "class", div2_class_value);
      }

      if (dirty[0] &
      /*position, disabled, themeVariants*/
      1036 && div3_class_value !== (div3_class_value = "" + (
      /*style*/
      ctx[12].are("_dropdownInner",
      /*position*/
      ctx[2]) + " " +
      /*style*/
      ctx[12].if("disabled",
      /*disabled*/
      ctx[3]) + " " +
      /*themeVariants*/
      ctx[10]))) {
        attr(div3, "class", div3_class_value);
      }

      if (dirty[0] &
      /*$altStyles, theme, themeVariants*/
      1312 && div4_class_value !== (div4_class_value = "" + (
      /*style*/
      ctx[12].is("dropdown") + " " +
      /*$altStyles*/
      ctx[8].part("theme/".concat(
      /*theme*/
      ctx[5], "/dropdown")) + " " +
      /*themeVariants*/
      ctx[10]))) {
        attr(div4, "class", div4_class_value);
      }
    },
    i: noop,
    o: noop,
    d: function d(detaching) {
      if (if_block0) if_block0.d(detaching);
      detach(if_block0_anchor);
      if (detaching) detach(t0);
      if (if_block1) if_block1.d(detaching);
      if (detaching) detach(t1);
      if (detaching) detach(div4);
      /*div1_binding*/

      ctx[40](null);
      run_all(dispose);
    }
  };
}

function removeOpenAttr(slottedTriggers) {
  slottedTriggers.forEach(function (trigger) {
    trigger.removeAttribute("open");
  });
}

function instance($$self, $$props, $$invalidate) {
  var $altStyles;
  component_subscribe($$self, dropdownStyleStore, function ($$value) {
    return $$invalidate(8, $altStyles = $$value);
  });
  var stylesheet = "<style id=\"dropdown-styles\">".concat(styles, "</style>");
  var style = new StyleUtilities(dropdownStyles);
  var dropdownElement, hostElement, menuSlotElement;
  var alignFlipped = false,
      positionFlipped = false;
  var lastCall = null,
      lastDuration = null,
      pendingTimeout = null; // Update menu position on menu open/close and tick

  function initialize(node) {
    dropdownElement = node;
    hostElement = node.parentNode.host;
    node.addEventListener("dlsdropdowntriggertoggle", onTriggerToggle);
    return {
      destroy: function destroy() {
        node.removeEventListener("dlsdropdowntriggertoggle", onTriggerToggle);
        removeMenuPositionListeners();
      }
    };
  }

  function onTriggerToggle(event) {
    if (!disabled) {
      $$invalidate(1, open = event.detail.open);

      if (open) {
        openMenu();
      } else {
        closeMenu();
      }

      dispatchToggleEvent(open);
    }
  }

  function openMenu() {
    hostElement.setAttribute("open", "open");
    addMenuPositionListeners();
    positionMenu();
  }

  function closeMenu() {
    hostElement.removeAttribute("open");
    resetPreferredOrientation();
    removeMenuPositionListeners();
  }

  function autoCloseMenu(event) {
    var target = event.target,
        path = event.path;
    var isSameDropdown = path.indexOf(hostElement) >= 0;

    if (isSameDropdown || slottedTriggers.find(function (node) {
      return node.isSameNode(target);
    })) {
      return;
    }

    var _menuSlotElement$getB = menuSlotElement.getBoundingClientRect(),
        bottom = _menuSlotElement$getB.bottom,
        left = _menuSlotElement$getB.left,
        right = _menuSlotElement$getB.right,
        top = _menuSlotElement$getB.top;

    var clientX = event.clientX,
        clientY = event.clientY;
    var isHorizontallyBound = left <= clientX && clientX <= right;
    var isVerticallyBound = top <= clientY && clientY <= bottom;

    if (isHorizontallyBound && isVerticallyBound) {
      return;
    }

    closeMenu();
    dispatchToggleEvent(false);
    removeOpenAttr(slottedTriggers);
  }

  function dispatchToggleEvent(open) {
    hostElement.dispatchEvent(new CustomEvent("dlsdropdowntoggle", {
      bubbles: true,
      composed: true,
      detail: {
        open: open
      }
    }));
  }

  function addMenuPositionListeners() {
    ["resize", "scroll", "touchmove"].forEach(function (event) {
      window.addEventListener(event, tick);
    });
  }

  function removeMenuPositionListeners() {
    ["resize", "scroll", "touchmove"].forEach(function (event) {
      window.removeEventListener(event, tick);
    });
  }

  function checkPreferredOrientation() {
    var defaultAlign = hostElement.getAttribute("align") || "left";
    var defaultPosition = hostElement.getAttribute("position") || "bottom";
    alignFlipped = align !== defaultAlign;
    positionFlipped = position !== defaultPosition;
  }

  function resetPreferredOrientation() {
    $$invalidate(0, align = hostElement.getAttribute("align") || "left");
    $$invalidate(2, position = hostElement.getAttribute("position") || "bottom");
  }

  function positionMenu() {
    var pageBounds = document.body.getBoundingClientRect();
    var dropdownBounds = dropdownElement.getBoundingClientRect();
    var menuWidth = menuSlotElement.offsetWidth;
    var menuHeight = menuSlotElement.offsetHeight;
    var windowHeight = window.innerHeight;
    var collisions = {
      top: dropdownBounds.top - menuHeight < 0,
      right: pageBounds.width < dropdownBounds.left + menuWidth,
      bottom: windowHeight < dropdownBounds.top + dropdownBounds.height + menuHeight,
      left: dropdownBounds.right - menuWidth < 0
    };
    checkPreferredOrientation();

    if (collisions.bottom) {
      $$invalidate(2, position = "top");
    } else if (positionFlipped) {
      $$invalidate(2, position = "bottom");
    }

    if (collisions.top) {
      $$invalidate(2, position = "bottom");
    } else if (positionFlipped) {
      $$invalidate(2, position = "top");
    }

    if (collisions.right) {
      $$invalidate(0, align = "right");
    } else if (alignFlipped) {
      $$invalidate(0, align = "left");
    }

    if (collisions.left) {
      $$invalidate(0, align = "left");
    } else if (alignFlipped) {
      $$invalidate(0, align = "right");
    }
  }

  var tick = function tick() {
    /* Lightly modified from tether.js */
    if (typeof lastDuration !== "undefined" && lastDuration > 16) {
      // We voluntarily throttle ourselves if we can't manage 60fps
      lastDuration = Math.min(lastDuration - 16, 250); // Just in case this is the last event, remember to position just once more

      pendingTimeout = setTimeout(tick, 250);
      return;
    }

    if (typeof lastCall !== "undefined" && Date.now() - lastCall < 10) {
      // Some browsers call events a little too frequently, refuse to run more than is reasonable
      return;
    }

    if (pendingTimeout != null) {
      clearTimeout(pendingTimeout);
      pendingTimeout = null;
    }

    lastCall = Date.now();
    positionMenu();
    lastDuration = Date.now() - lastCall;
  }; // Report current selected _valuelist to all slotted children


  var slottedChildren = [];
  var slottedTriggers = [];
  var getSlottedChildren = getSlotChangeHandler(undefined, function onAfterHandle(event, newSlottedChildren) {
    $$invalidate(25, slottedChildren = newSlottedChildren);
  });
  var getSlottedTriggers = getSlotChangeHandler(undefined, function onAfterHandle(event, newSlottedChildren) {
    slottedTriggers = newSlottedChildren.reduce(function (collection, node) {
      var flattenedDecendants = node.parentElement.getElementsByTagName("*");
      var triggerNodes = Array.from(flattenedDecendants).filter(function (node) {
        return node.tagName.indexOf("TRIGGER") !== -1;
      });
      return collection.concat(triggerNodes);
    }, []);
  }); // Style and theme

  function getThemeVariants(align, disabled, open, position, theme) {
    var variants = [align && $altStyles.variant("theme/".concat(theme, "/").concat(align)), disabled && $altStyles.variant("theme/".concat(theme, "/disabled")), open && $altStyles.variant("theme/".concat(theme, "/open")), position && $altStyles.variant("theme/".concat(theme, "/").concat(position))].filter(Boolean).join(" ");
    return variants.length ? variants : "";
  }

  function generatePolyfillStyleTags() {
    var tags = polyfillStyleTags;

    if (dropdownStyleStore.isNewStylesheet("dropdown-styles")) {
      tags += stylesheet;
    }

    if (dropdownStyleStore.isNewStylesheet("theme/".concat(theme))) {
      tags += $altStyles.sheet("theme/".concat(theme));
    }

    return tags;
  }

  var _$$props$_valuelist = $$props._valuelist,
      _valuelist = _$$props$_valuelist === void 0 ? [] : _$$props$_valuelist;

  var _$$props$align = $$props.align,
      align = _$$props$align === void 0 ? "left" : _$$props$align;
  var _$$props$disabled = $$props.disabled,
      disabled = _$$props$disabled === void 0 ? false : _$$props$disabled;
  var _$$props$noscroll = $$props.noscroll,
      noscroll = _$$props$noscroll === void 0 ? false : _$$props$noscroll;
  var _$$props$open = $$props.open,
      open = _$$props$open === void 0 ? false : _$$props$open;
  var _$$props$position = $$props.position,
      position = _$$props$position === void 0 ? "bottom" : _$$props$position;
  var _$$props$theme = $$props.theme,
      theme = _$$props$theme === void 0 ? "" : _$$props$theme;
  var _$$props$wrapmenu = $$props.wrapmenu,
      wrapmenu = _$$props$wrapmenu === void 0 ? false : _$$props$wrapmenu;
  var _$$props$autoclose = $$props.autoclose,
      autoclose = _$$props$autoclose === void 0 ? false : _$$props$autoclose;

  function div1_binding($$value) {
    binding_callbacks[$$value ? "unshift" : "push"](function () {
      $$invalidate(7, menuSlotElement = $$value);
    });
  }

  $$self.$set = function ($$props) {
    if ("_valuelist" in $$props) $$invalidate(16, _valuelist = $$props._valuelist);
    if ("align" in $$props) $$invalidate(0, align = $$props.align);
    if ("disabled" in $$props) $$invalidate(3, disabled = $$props.disabled);
    if ("noscroll" in $$props) $$invalidate(4, noscroll = $$props.noscroll);
    if ("open" in $$props) $$invalidate(1, open = $$props.open);
    if ("position" in $$props) $$invalidate(2, position = $$props.position);
    if ("theme" in $$props) $$invalidate(5, theme = $$props.theme);
    if ("wrapmenu" in $$props) $$invalidate(6, wrapmenu = $$props.wrapmenu);
    if ("autoclose" in $$props) $$invalidate(17, autoclose = $$props.autoclose);
  };

  var themeVariants;
  var polyfillStyleTags;

  $$self.$$.update = function () {
    if ($$self.$$.dirty[0] &
    /*open, autoclose*/
    131074) {
      registerAutoCloseListener(open, autoclose, autoCloseMenu);
    }

    if ($$self.$$.dirty[0] &
    /*slottedChildren, _valuelist*/
    33619968) {
      updateItemSelections(slottedChildren, _valuelist);
    }

    if ($$self.$$.dirty[0] &
    /*align, disabled, open, position, theme*/
    47) {
      $$invalidate(10, themeVariants = getThemeVariants(align, disabled, open, position, theme));
    }

    if ($$self.$$.dirty[0] &
    /*theme*/
    32) {
      $$invalidate(9, polyfillStyleTags = style.usesPolyfill ? generatePolyfillStyleTags() : null);
    }
  };

  return [align, open, position, disabled, noscroll, theme, wrapmenu, menuSlotElement, $altStyles, polyfillStyleTags, themeVariants, stylesheet, style, initialize, getSlottedChildren, getSlottedTriggers, _valuelist, autoclose, dropdownElement, hostElement, alignFlipped, positionFlipped, lastCall, lastDuration, pendingTimeout, slottedChildren, slottedTriggers, onTriggerToggle, openMenu, closeMenu, autoCloseMenu, dispatchToggleEvent, addMenuPositionListeners, removeMenuPositionListeners, checkPreferredOrientation, resetPreferredOrientation, positionMenu, tick, getThemeVariants, generatePolyfillStyleTags, div1_binding];
}

var DlsDropdowns =
/*#__PURE__*/
function (_SvelteElement) {
  _inherits(DlsDropdowns, _SvelteElement);

  function DlsDropdowns(options) {
    var _this;

    _classCallCheck(this, DlsDropdowns);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DlsDropdowns).call(this));
    init(_assertThisInitialized(_this), {
      target: _this.shadowRoot
    }, instance, create_fragment, safe_not_equal, {
      _valuelist: 16,
      align: 0,
      disabled: 3,
      noscroll: 4,
      open: 1,
      position: 2,
      theme: 5,
      wrapmenu: 6,
      autoclose: 17
    }, [-1, -1]);

    if (options) {
      if (options.target) {
        insert(options.target, _assertThisInitialized(_this), options.anchor);
      }

      if (options.props) {
        _this.$set(options.props);

        flush();
      }
    }

    return _this;
  }

  _createClass(DlsDropdowns, [{
    key: "_valuelist",
    get: function get() {
      return this.$$.ctx[16];
    },
    set: function set(_valuelist) {
      this.$set({
        _valuelist: _valuelist
      });
      flush();
    }
  }, {
    key: "align",
    get: function get() {
      return this.$$.ctx[0];
    },
    set: function set(align) {
      this.$set({
        align: align
      });
      flush();
    }
  }, {
    key: "disabled",
    get: function get() {
      return this.$$.ctx[3];
    },
    set: function set(disabled) {
      this.$set({
        disabled: disabled
      });
      flush();
    }
  }, {
    key: "noscroll",
    get: function get() {
      return this.$$.ctx[4];
    },
    set: function set(noscroll) {
      this.$set({
        noscroll: noscroll
      });
      flush();
    }
  }, {
    key: "open",
    get: function get() {
      return this.$$.ctx[1];
    },
    set: function set(open) {
      this.$set({
        open: open
      });
      flush();
    }
  }, {
    key: "position",
    get: function get() {
      return this.$$.ctx[2];
    },
    set: function set(position) {
      this.$set({
        position: position
      });
      flush();
    }
  }, {
    key: "theme",
    get: function get() {
      return this.$$.ctx[5];
    },
    set: function set(theme) {
      this.$set({
        theme: theme
      });
      flush();
    }
  }, {
    key: "wrapmenu",
    get: function get() {
      return this.$$.ctx[6];
    },
    set: function set(wrapmenu) {
      this.$set({
        wrapmenu: wrapmenu
      });
      flush();
    }
  }, {
    key: "autoclose",
    get: function get() {
      return this.$$.ctx[17];
    },
    set: function set(autoclose) {
      this.$set({
        autoclose: autoclose
      });
      flush();
    }
  }], [{
    key: "observedAttributes",
    get: function get() {
      return ["_valuelist", "align", "disabled", "noscroll", "open", "position", "theme", "wrapmenu", "autoclose"];
    }
  }]);

  return DlsDropdowns;
}(SvelteElement);

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var triggerControl = "mc44e89a5d_triggerControl";
var text$1 = "mc44e89a5d_text";
var link = "mc44e89a5d_link";
var disabled = "mc44e89a5d_disabled";
var styles$1 = ".mc44e89a5d_triggerControl.mc44e89a5d_text{color:#3e3939}.mc44e89a5d_triggerControl.mc44e89a5d_link{color:#007e8c}.mc44e89a5d_triggerControl.mc44e89a5d_link.mc44e89a5d_open,.mc44e89a5d_triggerControl.mc44e89a5d_link:focus,.mc44e89a5d_triggerControl.mc44e89a5d_link:hover{color:#006373}.mc44e89a5d_triggerControl.mc44e89a5d_disabled,.mc44e89a5d_triggerControl[disabled]{color:#706f6e}";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var iconButtonDefinition = {
  attributeName: 'type',
  attributeValue: 'icon',
  className: 'ignore',
  component: 'dls-dropdown-trigger',
  styles: styles$1,
  parts: {
    triggerControl: triggerControl
  },
  variations: {
    disabled: disabled,
    link: link,
    text: text$1
  }
};
addStyles([iconButtonDefinition, _objectSpread({}, iconButtonDefinition, {
  attributeValue: 'button'
})]);
var triggerControl$1 = "mc69889978_dls-typography-desktop-body-reg-medium mc69889978_triggerControl";
var open$1 = "mc69889978_open";
var placeholder = "mc69889978_placeholder";
var triggerLabel = "mc69889978_triggerLabel";
var triggerIcon = "mc69889978_triggerIcon";
var disabled$1 = "mc69889978_disabled";
var styles$2 = ".mc69889978_triggerControl{border-radius:2px;height:52px;margin:0;padding:0 16px;transition:background-color .12s,box-shadow .12s ease-out,border-color .12s ease-out}.mc69889978_triggerLabel{padding-right:8px}.mc69889978_dls-typography-desktop-body-reg-medium{font-family:Lab Grotesque,sans-serif;font-weight:400;text-transform:none;font-size:16px;letter-spacing:0;line-height:24px}.mc69889978_triggerControl{background:#fff;border:1px solid #e0e3e4;color:#3e3939;transition:box-shadow .12s ease-out,border-color .12s ease-out}.mc69889978_triggerControl:-ms-input-placeholder{color:#706f6e}.mc69889978_triggerControl::-ms-input-placeholder{color:#706f6e}.mc69889978_triggerControl.mc69889978_placeholder,.mc69889978_triggerControl::placeholder{color:#706f6e}.mc69889978_triggerLabel{flex:1 0 auto;max-width:calc(100% - 24px)}.mc69889978_triggerControl.mc69889978_open,.mc69889978_triggerControl:focus,.mc69889978_triggerControl:hover{background:#fff;border-color:#706f6e;outline:0;transition-duration:.3s}.mc69889978_triggerIcon{color:#007e8c}.mc69889978_triggerIcon.mc69889978_open{color:#006373}.mc69889978_triggerControl.mc69889978_disabled,.mc69889978_triggerControl[disabled]{background-color:#eee;border-color:#e0e3e4;color:#3e3939}.mc69889978_triggerLabel.mc69889978_disabled{color:#3e3939}.mc69889978_triggerIcon.mc69889978_disabled{color:#3e3939}";
addStyles([{
  attributeName: 'theme',
  attributeValue: 'field',
  className: 'ignore',
  component: 'dls-dropdown-trigger',
  styles: styles$2,
  parts: {
    triggerControl: triggerControl$1,
    triggerIcon: triggerIcon,
    triggerLabel: triggerLabel
  },
  variations: {
    disabled: disabled$1,
    open: open$1,
    placeholder: placeholder
  }
}]); // TODO: we check for text in slotted nodes in 3 different ways:
// innerText, textContent, and nodeValue

function filterNodes(node) {
  // Non-empty text nodes
  return node.innerText && node.innerText.trim().length || node.nodeValue && node.nodeValue.trim().length;
}

function normalizeItemLabel(label) {
  if (typeof label === 'string' && label.trim().length) {
    return label.trim();
  }

  return '';
}

function normalizeLabelList(_labellist, multiple) {
  var label = '';

  if (Array.isArray(_labellist) && _labellist.length) {
    if (multiple) {
      label = _labellist.map(function (l) {
        return l.trim();
      }).join(', ');
    } else {
      label = _labellist[_labellist.length - 1];
    }
  } else if (typeof _labellist === 'string') {
    label = _labellist;
  }

  return label.trim();
}

function normalizeTriggerLabel(slottedChildren, triggerlabel, formattedLabel) {
  var formattedTriggerLabel = normalizeItemLabel(triggerlabel);

  if (formattedTriggerLabel.length) {
    return formattedTriggerLabel;
  } else if (slottedChildren && slottedChildren.length) {
    var formattedSlotLabel = slottedChildren.reduce(function () {
      var label = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var node = arguments.length > 1 ? arguments[1] : undefined;
      var nodeText = node.nodeType === Node.TEXT_NODE ? node.nodeValue : node.innerText;
      label.push((nodeText || '').trim());
      return label;
    }, []).join(' ').trim();

    if (formattedSlotLabel.length) {
      return formattedSlotLabel;
    }
  }

  return normalizeItemLabel(formattedLabel);
}

var trigger = {
  "trigger": "mc1cfadd84_trigger",
  "triggerControl": "mc1cfadd84_triggerControl",
  "disabled": "mc1cfadd84_disabled",
  "open": "mc1cfadd84_open",
  "placeholder": "mc1cfadd84_placeholder",
  "triggerLabel": "mc1cfadd84_triggerLabel",
  "triggerIcon": "mc1cfadd84_triggerIcon"
};
var trigger$1 = "mc1cfadd84_trigger";
var triggerControl$2 = "mc1cfadd84_triggerControl";
var disabled$2 = "mc1cfadd84_disabled";
var open$2 = "mc1cfadd84_open";
var placeholder$1 = "mc1cfadd84_placeholder";
var triggerLabel$1 = "mc1cfadd84_triggerLabel";
var triggerIcon$1 = "mc1cfadd84_triggerIcon";
var styles$3 = ".mc1cfadd84_trigger,.mc1cfadd84_triggerControl{cursor:pointer;outline:0}.mc1cfadd84_disabled .mc1cfadd84_triggerControl,.mc1cfadd84_trigger.mc1cfadd84_disabled,.mc1cfadd84_trigger[disabled],.mc1cfadd84_triggerControl.mc1cfadd84_disabled,.mc1cfadd84_triggerControl[disabled],[disabled] .mc1cfadd84_triggerControl{cursor:auto;pointer-events:none}.mc1cfadd84_triggerControl{-webkit-appearance:none;align-items:center;background:transparent;box-sizing:border-box;display:flex;width:100%}.mc1cfadd84_triggerControl:-ms-input-placeholder{color:var(--control-placeholder-text-color)}.mc1cfadd84_triggerControl::-ms-input-placeholder{color:var(--control-placeholder-text-color)}.mc1cfadd84_triggerControl.mc1cfadd84_placeholder,.mc1cfadd84_triggerControl::placeholder{color:var(--control-placeholder-text-color)}.mc1cfadd84_triggerLabel{overflow:hidden;text-align:left;text-overflow:ellipsis;white-space:nowrap}.mc1cfadd84_triggerIcon,.mc1cfadd84_triggerLabel{pointer-events:none}.mc1cfadd84_triggerIcon.mc1cfadd84_open{transform:scaleY(-1)}[data-style]{display:none}";
var triggerStyles =
/*#__PURE__*/
Object.freeze({
  __proto__: null,
  'default': trigger,
  trigger: trigger$1,
  triggerControl: triggerControl$2,
  disabled: disabled$2,
  open: open$2,
  placeholder: placeholder$1,
  triggerLabel: triggerLabel$1,
  triggerIcon: triggerIcon$1,
  styles: styles$3
});

function create_if_block_3(ctx) {
  var html_tag;
  return {
    c: function c() {
      html_tag = new HtmlTag(
      /*polyfillStyleTags*/
      ctx[5], null);
    },
    m: function m(target, anchor) {
      html_tag.m(target, anchor);
    },
    p: function p(ctx, dirty) {
      if (dirty &
      /*polyfillStyleTags*/
      32) html_tag.p(
      /*polyfillStyleTags*/
      ctx[5]);
    },
    d: function d(detaching) {
      if (detaching) html_tag.d();
    }
  };
} // (12:0) {#if !style.usesPolyfill}


function create_if_block_2(ctx) {
  var div0;
  var t0;
  var div1;
  var raw1_value =
  /*$altStyles*/
  ctx[4].sheet("theme/".concat(
  /*theme*/
  ctx[1])) + "";
  var t1;
  var div2;
  var raw2_value =
  /*$altStyles*/
  ctx[4].sheet("type/".concat(
  /*type*/
  ctx[3])) + "";
  return {
    c: function c() {
      div0 = element("div");
      t0 = space();
      div1 = element("div");
      t1 = space();
      div2 = element("div");
      attr(div0, "data-style", "");
      attr(div1, "data-style", "");
      attr(div2, "data-style", "");
    },
    m: function m(target, anchor) {
      insert(target, div0, anchor);
      div0.innerHTML =
      /*stylesheet*/
      ctx[10];
      insert(target, t0, anchor);
      insert(target, div1, anchor);
      div1.innerHTML = raw1_value;
      insert(target, t1, anchor);
      insert(target, div2, anchor);
      div2.innerHTML = raw2_value;
    },
    p: function p(ctx, dirty) {
      if (dirty &
      /*$altStyles, theme*/
      18 && raw1_value !== (raw1_value =
      /*$altStyles*/
      ctx[4].sheet("theme/".concat(
      /*theme*/
      ctx[1])) + "")) div1.innerHTML = raw1_value;
      if (dirty &
      /*$altStyles, type*/
      24 && raw2_value !== (raw2_value =
      /*$altStyles*/
      ctx[4].sheet("type/".concat(
      /*type*/
      ctx[3])) + "")) div2.innerHTML = raw2_value;
    },
    d: function d(detaching) {
      if (detaching) detach(div0);
      if (detaching) detach(t0);
      if (detaching) detach(div1);
      if (detaching) detach(t1);
      if (detaching) detach(div2);
    }
  };
} // (37:49) 


function create_if_block_1$1(ctx) {
  var dls_button;
  var slot0;
  var t;
  var slot1;
  var dls_button_class_value;
  return {
    c: function c() {
      dls_button = element("dls-button");
      slot0 = element("slot");
      t = space();
      slot1 = element("slot");
      attr(slot0, "name", "dropdown-trigger-icon");
      attr(slot0, "slot", "button-icon");
      attr(slot1, "slot", "button-icon");
      set_custom_element_data(dls_button, "class", dls_button_class_value = "" + (
      /*style*/
      ctx[11].is("triggerControl") + " " +
      /*buttonVariations*/
      ctx[6]));
      set_custom_element_data(dls_button, "disable",
      /*disabled*/
      ctx[2]);
      set_custom_element_data(dls_button, "label",
      /*formattedLabel*/
      ctx[7]);
      set_custom_element_data(dls_button, "pressed",
      /*open*/
      ctx[0]);
      set_custom_element_data(dls_button, "shape",
      /*shape*/
      ctx[9]);
      set_custom_element_data(dls_button, "theme",
      /*theme*/
      ctx[1]);
      set_custom_element_data(dls_button, "toggle", "toggle");
    },
    m: function m(target, anchor) {
      insert(target, dls_button, anchor);
      append(dls_button, slot0);
      append(dls_button, t);
      append(dls_button, slot1);
    },
    p: function p(ctx, dirty) {
      if (dirty &
      /*buttonVariations*/
      64 && dls_button_class_value !== (dls_button_class_value = "" + (
      /*style*/
      ctx[11].is("triggerControl") + " " +
      /*buttonVariations*/
      ctx[6]))) {
        set_custom_element_data(dls_button, "class", dls_button_class_value);
      }

      if (dirty &
      /*disabled*/
      4) {
        set_custom_element_data(dls_button, "disable",
        /*disabled*/
        ctx[2]);
      }

      if (dirty &
      /*formattedLabel*/
      128) {
        set_custom_element_data(dls_button, "label",
        /*formattedLabel*/
        ctx[7]);
      }

      if (dirty &
      /*open*/
      1) {
        set_custom_element_data(dls_button, "pressed",
        /*open*/
        ctx[0]);
      }

      if (dirty &
      /*shape*/
      512) {
        set_custom_element_data(dls_button, "shape",
        /*shape*/
        ctx[9]);
      }

      if (dirty &
      /*theme*/
      2) {
        set_custom_element_data(dls_button, "theme",
        /*theme*/
        ctx[1]);
      }
    },
    d: function d(detaching) {
      if (detaching) detach(dls_button);
    }
  };
} // (24:2) {#if type === 'select'}


function create_if_block$1(ctx) {
  var button;
  var span;
  var t0;
  var span_class_value;
  var t1;
  var dls_icon_chevron_down;
  var dls_icon_chevron_down_class_value;
  var button_class_value;
  return {
    c: function c() {
      button = element("button");
      span = element("span");
      t0 = text(
      /*formattedLabel*/
      ctx[7]);
      t1 = space();
      dls_icon_chevron_down = element("dls-icon-chevron-down");
      attr(span, "class", span_class_value = "" + (
      /*style*/
      ctx[11].is("triggerLabel") + " " +
      /*selectVariations*/
      ctx[8] + " " +
      /*$altStyles*/
      ctx[4].part("theme/".concat(
      /*theme*/
      ctx[1], "/triggerLabel"))));
      set_custom_element_data(dls_icon_chevron_down, "class", dls_icon_chevron_down_class_value = "" + (
      /*style*/
      ctx[11].is("triggerIcon") + " " +
      /*selectVariations*/
      ctx[8] + " " +
      /*$altStyles*/
      ctx[4].part("theme/".concat(
      /*theme*/
      ctx[1], "/triggerIcon"))));
      attr(button, "class", button_class_value = "" + (
      /*style*/
      ctx[11].is("triggerControl") + " " +
      /*selectVariations*/
      ctx[8] + " " +
      /*$altStyles*/
      ctx[4].part("theme/".concat(
      /*theme*/
      ctx[1], "/triggerControl"))));
      button.disabled =
      /*disabled*/
      ctx[2];
    },
    m: function m(target, anchor) {
      insert(target, button, anchor);
      append(button, span);
      append(span, t0);
      append(button, t1);
      append(button, dls_icon_chevron_down);
    },
    p: function p(ctx, dirty) {
      if (dirty &
      /*formattedLabel*/
      128) set_data(t0,
      /*formattedLabel*/
      ctx[7]);

      if (dirty &
      /*selectVariations, $altStyles, theme*/
      274 && span_class_value !== (span_class_value = "" + (
      /*style*/
      ctx[11].is("triggerLabel") + " " +
      /*selectVariations*/
      ctx[8] + " " +
      /*$altStyles*/
      ctx[4].part("theme/".concat(
      /*theme*/
      ctx[1], "/triggerLabel"))))) {
        attr(span, "class", span_class_value);
      }

      if (dirty &
      /*selectVariations, $altStyles, theme*/
      274 && dls_icon_chevron_down_class_value !== (dls_icon_chevron_down_class_value = "" + (
      /*style*/
      ctx[11].is("triggerIcon") + " " +
      /*selectVariations*/
      ctx[8] + " " +
      /*$altStyles*/
      ctx[4].part("theme/".concat(
      /*theme*/
      ctx[1], "/triggerIcon"))))) {
        set_custom_element_data(dls_icon_chevron_down, "class", dls_icon_chevron_down_class_value);
      }

      if (dirty &
      /*selectVariations, $altStyles, theme*/
      274 && button_class_value !== (button_class_value = "" + (
      /*style*/
      ctx[11].is("triggerControl") + " " +
      /*selectVariations*/
      ctx[8] + " " +
      /*$altStyles*/
      ctx[4].part("theme/".concat(
      /*theme*/
      ctx[1], "/triggerControl"))))) {
        attr(button, "class", button_class_value);
      }

      if (dirty &
      /*disabled*/
      4) {
        button.disabled =
        /*disabled*/
        ctx[2];
      }
    },
    d: function d(detaching) {
      if (detaching) detach(button);
    }
  };
}

function create_fragment$1(ctx) {
  var if_block0_anchor;
  var t0;
  var t1;
  var div;
  var div_class_value;
  var initialize_action;
  var dispose;
  var if_block0 =
  /*style*/
  ctx[11].usesPolyfill && create_if_block_3(ctx);
  var if_block1 = !
  /*style*/
  ctx[11].usesPolyfill && create_if_block_2(ctx);

  function select_block_type(ctx, dirty) {
    if (
    /*type*/
    ctx[3] === "select") return create_if_block$1;
    if (
    /*type*/
    ctx[3] === "button" ||
    /*type*/
    ctx[3] === "icon") return create_if_block_1$1;
  }

  var current_block_type = select_block_type(ctx);
  var if_block2 = current_block_type && current_block_type(ctx);
  return {
    c: function c() {
      if (if_block0) if_block0.c();
      if_block0_anchor = empty();
      t0 = space();
      if (if_block1) if_block1.c();
      t1 = space();
      div = element("div");
      if (if_block2) if_block2.c();
      this.c = noop;
      attr(div, "class", div_class_value = "" + (
      /*style*/
      ctx[11].is("trigger") + " " +
      /*style*/
      ctx[11].if("disabled",
      /*disabled*/
      ctx[2]) + " " +
      /*$altStyles*/
      ctx[4].part("theme/".concat(
      /*theme*/
      ctx[1], "/trigger"))));
      attr(div, "data-hook", "dls-dropdown-trigger");
      attr(div, "tabindex", "-1");
    },
    m: function m(target, anchor) {
      if (if_block0) if_block0.m(document.head, null);
      append(document.head, if_block0_anchor);
      insert(target, t0, anchor);
      if (if_block1) if_block1.m(target, anchor);
      insert(target, t1, anchor);
      insert(target, div, anchor);
      if (if_block2) if_block2.m(div, null);
      dispose = action_destroyer(initialize_action =
      /*initialize*/
      ctx[12].call(null, div));
    },
    p: function p(ctx, _ref) {
      var _ref2 = _slicedToArray(_ref, 1),
          dirty = _ref2[0];

      if (
      /*style*/
      ctx[11].usesPolyfill) if_block0.p(ctx, dirty);
      if (!
      /*style*/
      ctx[11].usesPolyfill) if_block1.p(ctx, dirty);

      if (current_block_type === (current_block_type = select_block_type(ctx)) && if_block2) {
        if_block2.p(ctx, dirty);
      } else {
        if (if_block2) if_block2.d(1);
        if_block2 = current_block_type && current_block_type(ctx);

        if (if_block2) {
          if_block2.c();
          if_block2.m(div, null);
        }
      }

      if (dirty &
      /*disabled, $altStyles, theme*/
      22 && div_class_value !== (div_class_value = "" + (
      /*style*/
      ctx[11].is("trigger") + " " +
      /*style*/
      ctx[11].if("disabled",
      /*disabled*/
      ctx[2]) + " " +
      /*$altStyles*/
      ctx[4].part("theme/".concat(
      /*theme*/
      ctx[1], "/trigger"))))) {
        attr(div, "class", div_class_value);
      }
    },
    i: noop,
    o: noop,
    d: function d(detaching) {
      if (if_block0) if_block0.d(detaching);
      detach(if_block0_anchor);
      if (detaching) detach(t0);
      if (if_block1) if_block1.d(detaching);
      if (detaching) detach(t1);
      if (detaching) detach(div);

      if (if_block2) {
        if_block2.d();
      }

      dispose();
    }
  };
}

function instance$1($$self, $$props, $$invalidate) {
  var $altStyles;
  component_subscribe($$self, dropdownStyleStore, function ($$value) {
    return $$invalidate(4, $altStyles = $$value);
  });
  var stylesheet = "<style id=\"trigger-styles\">".concat(styles$3, "</style>");
  var style = new StyleUtilities(triggerStyles);
  var hostElement;

  function initialize(node) {
    hostElement = node.parentNode.host; // experiment instead of on:click="{toggleTrigger}"

    hostElement.addEventListener("click", toggleTrigger);
  } // Report trigger toggling interaction


  function toggleTrigger(event) {
    if (!disabled) {
      $$invalidate(0, open = !open);

      if (open) {
        hostElement.setAttribute("open", "open");
      } else {
        hostElement.removeAttribute("open");
      }

      dispatchToggleEvent(open);
    }
  }

  function dispatchToggleEvent(open) {
    hostElement.dispatchEvent(new CustomEvent("dlsdropdowntriggertoggle", {
      bubbles: true,
      composed: true,
      detail: {
        open: open
      }
    }));
  } // Style and theme
  // TODO: icon and select can't use a very similar design for theming
  // currently: need to rethink how it's organized.


  function getButtonVariations(color, disabled, type) {
    var variants = [$altStyles.part("type/".concat(type, "/triggerControl")), color && $altStyles.variant("type/".concat(type, "/").concat(color)), disabled && $altStyles.variant("type/".concat(type, "/disabled"))].filter(Boolean).join(" ");
    return variants.length ? variants : "";
  }

  function getSelectVariants(color, disabled, hasLabel, open, theme) {
    var variants = [!hasLabel && style.is("placeholder"), !hasLabel && $altStyles.variant("theme/".concat(theme, "/placeholder")), color && $altStyles.variant("theme/".concat(theme, "/").concat(color)), disabled && style.is("disabled"), disabled && $altStyles.variant("theme/".concat(theme, "/disabled")), open && style.is("open"), open && $altStyles.variant("theme/".concat(theme, "/open"))].filter(Boolean).join(" ");
    return variants.length ? variants : "";
  }

  function generatePolyfillStyleTags() {
    var tags = polyfillStyleTags;

    if (dropdownStyleStore.isNewStylesheet("trigger-styles")) {
      tags += stylesheet;
    }

    if (dropdownStyleStore.isNewStylesheet("theme/".concat(theme))) {
      tags += $altStyles.sheet("theme/".concat(theme));
    }

    if (dropdownStyleStore.isNewStylesheet("type/".concat(type))) {
      tags += $altStyles.sheet("type/".concat(type));
    }

    return tags;
  }

  function changeDefaultTheme(type, theme) {
    if (type === "select") {
      return theme;
    }

    if (isDropdownTheme(theme)) {
      return type === "icon" ? "transparent" : "white";
    }

    return theme;
  }

  function isDropdownTheme(theme) {
    return !theme || theme === "field" || theme === "inline";
  }

  var _$$props$color = $$props.color,
      color = _$$props$color === void 0 ? "text" : _$$props$color;
  var _$$props$disabled = $$props.disabled,
      disabled = _$$props$disabled === void 0 ? false : _$$props$disabled;
  var _$$props$label = $$props.label,
      label = _$$props$label === void 0 ? "" : _$$props$label;
  var _$$props$open = $$props.open,
      open = _$$props$open === void 0 ? false : _$$props$open; // TODO: this might change to arrow or pressed

  var _$$props$placeholder = $$props.placeholder,
      placeholder = _$$props$placeholder === void 0 ? "" : _$$props$placeholder;
  var _$$props$theme = $$props.theme,
      theme = _$$props$theme === void 0 ? "field" : _$$props$theme;
  var _$$props$type = $$props.type,
      type = _$$props$type === void 0 ? "select" : _$$props$type;

  $$self.$set = function ($$props) {
    if ("color" in $$props) $$invalidate(13, color = $$props.color);
    if ("disabled" in $$props) $$invalidate(2, disabled = $$props.disabled);
    if ("label" in $$props) $$invalidate(14, label = $$props.label);
    if ("open" in $$props) $$invalidate(0, open = $$props.open);
    if ("placeholder" in $$props) $$invalidate(15, placeholder = $$props.placeholder);
    if ("theme" in $$props) $$invalidate(1, theme = $$props.theme);
    if ("type" in $$props) $$invalidate(3, type = $$props.type);
  };

  var buttonVariations;
  var hasLabel;
  var formattedLabel;
  var polyfillStyleTags;
  var selectVariations;
  var shape;

  $$self.$$.update = function () {
    if ($$self.$$.dirty &
    /*color, disabled, type*/
    8204) {
      $$invalidate(6, buttonVariations = getButtonVariations(color, disabled, type));
    }

    if ($$self.$$.dirty &
    /*label*/
    16384) {
      $$invalidate(18, hasLabel = Boolean(normalizeItemLabel(label).length));
    }

    if ($$self.$$.dirty &
    /*hasLabel, label, placeholder*/
    311296) {
      $$invalidate(7, formattedLabel = hasLabel ? normalizeItemLabel(label) : normalizeItemLabel(placeholder));
    }

    if ($$self.$$.dirty &
    /*type, theme*/
    10) {
      $$invalidate(1, theme = changeDefaultTheme(type, theme));
    }

    if ($$self.$$.dirty &
    /*theme, type*/
    10) {
      $$invalidate(5, polyfillStyleTags = style.usesPolyfill ? generatePolyfillStyleTags() : null);
    }

    if ($$self.$$.dirty &
    /*color, disabled, hasLabel, open, theme*/
    270343) {
      $$invalidate(8, selectVariations = getSelectVariants(color, disabled, hasLabel, open, theme));
    }

    if ($$self.$$.dirty &
    /*type*/
    8) {
      $$invalidate(9, shape = type === "icon" ? "circle" : "pill");
    }
  };

  return [open, theme, disabled, type, $altStyles, polyfillStyleTags, buttonVariations, formattedLabel, selectVariations, shape, stylesheet, style, initialize, color, label, placeholder];
}

var DlsDropdowns$1 =
/*#__PURE__*/
function (_SvelteElement) {
  _inherits(DlsDropdowns, _SvelteElement);

  function DlsDropdowns(options) {
    var _this;

    _classCallCheck(this, DlsDropdowns);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DlsDropdowns).call(this));
    init(_assertThisInitialized(_this), {
      target: _this.shadowRoot
    }, instance$1, create_fragment$1, safe_not_equal, {
      color: 13,
      disabled: 2,
      label: 14,
      open: 0,
      placeholder: 15,
      theme: 1,
      type: 3
    });

    if (options) {
      if (options.target) {
        insert(options.target, _assertThisInitialized(_this), options.anchor);
      }

      if (options.props) {
        _this.$set(options.props);

        flush();
      }
    }

    return _this;
  }

  _createClass(DlsDropdowns, [{
    key: "color",
    get: function get() {
      return this.$$.ctx[13];
    },
    set: function set(color) {
      this.$set({
        color: color
      });
      flush();
    }
  }, {
    key: "disabled",
    get: function get() {
      return this.$$.ctx[2];
    },
    set: function set(disabled) {
      this.$set({
        disabled: disabled
      });
      flush();
    }
  }, {
    key: "label",
    get: function get() {
      return this.$$.ctx[14];
    },
    set: function set(label) {
      this.$set({
        label: label
      });
      flush();
    }
  }, {
    key: "open",
    get: function get() {
      return this.$$.ctx[0];
    },
    set: function set(open) {
      this.$set({
        open: open
      });
      flush();
    }
  }, {
    key: "placeholder",
    get: function get() {
      return this.$$.ctx[15];
    },
    set: function set(placeholder) {
      this.$set({
        placeholder: placeholder
      });
      flush();
    }
  }, {
    key: "theme",
    get: function get() {
      return this.$$.ctx[1];
    },
    set: function set(theme) {
      this.$set({
        theme: theme
      });
      flush();
    }
  }, {
    key: "type",
    get: function get() {
      return this.$$.ctx[3];
    },
    set: function set(type) {
      this.$set({
        type: type
      });
      flush();
    }
  }], [{
    key: "observedAttributes",
    get: function get() {
      return ["color", "disabled", "label", "open", "placeholder", "theme", "type"];
    }
  }]);

  return DlsDropdowns;
}(SvelteElement);

var list = {
  "list": "mc4f786c6d_list"
};
var list$1 = "mc4f786c6d_list";
var styles$4 = ".mc4f786c6d_list{flex-direction:column;list-style-type:none;margin:0;outline:0;padding:0}[data-style]{display:none}";
var listStyles =
/*#__PURE__*/
Object.freeze({
  __proto__: null,
  'default': list,
  list: list$1,
  styles: styles$4
});
var listStyleStore = SvelteStyleStoreFactory();
var subscribe$2 = listStyleStore.subscribe,
    addStyles$1 = listStyleStore.addStyles;

function create_fragment$2(ctx) {
  var div0;
  var t0;
  var div1;
  var raw1_value =
  /*$altStyles*/
  ctx[1].sheet("theme/".concat(
  /*theme*/
  ctx[0])) + "";
  var t1;
  var ul;
  var slot0;
  var t2;
  var slot1;
  var ul_class_value;
  var initialize_action;
  var dispose;
  return {
    c: function c() {
      div0 = element("div");
      t0 = space();
      div1 = element("div");
      t1 = space();
      ul = element("ul");
      slot0 = element("slot");
      t2 = space();
      slot1 = element("slot");
      this.c = noop;
      attr(div0, "data-style", "");
      attr(div1, "data-style", "");
      attr(slot0, "name", "list-item");
      attr(ul, "class", ul_class_value = "" + (
      /*style*/
      ctx[3].is("list") + " " +
      /*$altStyles*/
      ctx[1].part("theme/".concat(
      /*theme*/
      ctx[0], "/list"))));
      attr(ul, "tabindex", "-1");
    },
    m: function m(target, anchor) {
      insert(target, div0, anchor);
      div0.innerHTML =
      /*stylesheet*/
      ctx[2];
      insert(target, t0, anchor);
      insert(target, div1, anchor);
      div1.innerHTML = raw1_value;
      insert(target, t1, anchor);
      insert(target, ul, anchor);
      append(ul, slot0);
      append(ul, t2);
      append(ul, slot1);
      dispose = [listen(slot0, "slotchange",
      /*getSlottedChildren*/
      ctx[5]), listen(slot1, "slotchange",
      /*getSlottedChildren*/
      ctx[5]), action_destroyer(initialize_action =
      /*initialize*/
      ctx[4].call(null, ul))];
    },
    p: function p(ctx, _ref) {
      var _ref2 = _slicedToArray(_ref, 1),
          dirty = _ref2[0];

      if (dirty &
      /*$altStyles, theme*/
      3 && raw1_value !== (raw1_value =
      /*$altStyles*/
      ctx[1].sheet("theme/".concat(
      /*theme*/
      ctx[0])) + "")) div1.innerHTML = raw1_value;

      if (dirty &
      /*$altStyles, theme*/
      3 && ul_class_value !== (ul_class_value = "" + (
      /*style*/
      ctx[3].is("list") + " " +
      /*$altStyles*/
      ctx[1].part("theme/".concat(
      /*theme*/
      ctx[0], "/list"))))) {
        attr(ul, "class", ul_class_value);
      }
    },
    i: noop,
    o: noop,
    d: function d(detaching) {
      if (detaching) detach(div0);
      if (detaching) detach(t0);
      if (detaching) detach(div1);
      if (detaching) detach(t1);
      if (detaching) detach(ul);
      run_all(dispose);
    }
  };
}

function instance$2($$self, $$props, $$invalidate) {
  var $altStyles;
  component_subscribe($$self, listStyleStore, function ($$value) {
    return $$invalidate(1, $altStyles = $$value);
  });
  var stylesheet = "<style>".concat(styles$4, "</style>");
  var style = new StyleUtilities(listStyles);
  var listElement, hostElement; // Update selected _valuelist on input and change events

  function initialize(node) {
    listElement = node;
    hostElement = node.parentNode.host;
    node.addEventListener("dlslistiteminput", updateValue);
    hostElement.addEventListener("dlslistchange", updateValue);
    return {
      destroy: function destroy() {
        node.removeEventListener("dlslistiteminput", updateValue);
        hostElement.removeEventListener("dlslistchange", updateValue);
      }
    };
  } // Report current selected _valuelist to all slotted children


  var slottedChildren = [];
  var getSlottedChildren = getSlotChangeHandler(undefined, function onAfterHandle(event, newSlottedChildren) {
    $$invalidate(12, slottedChildren = newSlottedChildren);
  });

  function updateValue(event) {
    if (event.target.isSameNode(hostElement)) {
      return;
    }

    event.stopPropagation();
    var changed;
    var value = event.detail.value;
    var label = event.detail.label;
    var selections = updateSelectedList(_labellist, _valuelist, label, value, multiple, toggleable);
    $$invalidate(7, _labellist = selections._labellist);
    $$invalidate(6, _valuelist = selections._valuelist);
    changed = selections.changed;

    if (changed) {
      dispatchChangeEvent(listElement, _labellist, _valuelist, label, value);
    }
  }

  var _$$props$_valuelist = $$props._valuelist,
      _valuelist = _$$props$_valuelist === void 0 ? [] : _$$props$_valuelist;

  var _$$props$_labellist = $$props._labellist,
      _labellist = _$$props$_labellist === void 0 ? [] : _$$props$_labellist;

  var _$$props$multiple = $$props.multiple,
      multiple = _$$props$multiple === void 0 ? false : _$$props$multiple;
  var _$$props$theme = $$props.theme,
      theme = _$$props$theme === void 0 ? "" : _$$props$theme;
  var _$$props$toggleable = $$props.toggleable,
      toggleable = _$$props$toggleable === void 0 ? false : _$$props$toggleable;

  $$self.$set = function ($$props) {
    if ("_valuelist" in $$props) $$invalidate(6, _valuelist = $$props._valuelist);
    if ("_labellist" in $$props) $$invalidate(7, _labellist = $$props._labellist);
    if ("multiple" in $$props) $$invalidate(8, multiple = $$props.multiple);
    if ("theme" in $$props) $$invalidate(0, theme = $$props.theme);
    if ("toggleable" in $$props) $$invalidate(9, toggleable = $$props.toggleable);
  };

  $$self.$$.update = function () {
    if ($$self.$$.dirty &
    /*slottedChildren, _valuelist*/
    4160) {
      updateItemSelections(slottedChildren, _valuelist);
    }
  };

  return [theme, $altStyles, stylesheet, style, initialize, getSlottedChildren, _valuelist, _labellist, multiple, toggleable];
}

var DlsDropdowns$2 =
/*#__PURE__*/
function (_SvelteElement) {
  _inherits(DlsDropdowns, _SvelteElement);

  function DlsDropdowns(options) {
    var _this;

    _classCallCheck(this, DlsDropdowns);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DlsDropdowns).call(this));
    init(_assertThisInitialized(_this), {
      target: _this.shadowRoot
    }, instance$2, create_fragment$2, safe_not_equal, {
      _valuelist: 6,
      _labellist: 7,
      multiple: 8,
      theme: 0,
      toggleable: 9
    });

    if (options) {
      if (options.target) {
        insert(options.target, _assertThisInitialized(_this), options.anchor);
      }

      if (options.props) {
        _this.$set(options.props);

        flush();
      }
    }

    return _this;
  }

  _createClass(DlsDropdowns, [{
    key: "_valuelist",
    get: function get() {
      return this.$$.ctx[6];
    },
    set: function set(_valuelist) {
      this.$set({
        _valuelist: _valuelist
      });
      flush();
    }
  }, {
    key: "_labellist",
    get: function get() {
      return this.$$.ctx[7];
    },
    set: function set(_labellist) {
      this.$set({
        _labellist: _labellist
      });
      flush();
    }
  }, {
    key: "multiple",
    get: function get() {
      return this.$$.ctx[8];
    },
    set: function set(multiple) {
      this.$set({
        multiple: multiple
      });
      flush();
    }
  }, {
    key: "theme",
    get: function get() {
      return this.$$.ctx[0];
    },
    set: function set(theme) {
      this.$set({
        theme: theme
      });
      flush();
    }
  }, {
    key: "toggleable",
    get: function get() {
      return this.$$.ctx[9];
    },
    set: function set(toggleable) {
      this.$set({
        toggleable: toggleable
      });
      flush();
    }
  }], [{
    key: "observedAttributes",
    get: function get() {
      return ["_valuelist", "_labellist", "multiple", "theme", "toggleable"];
    }
  }]);

  return DlsDropdowns;
}(SvelteElement);

var listItem = {
  "dls-typography-desktop-body-reg-medium": "mc16e5a781_dls-typography-desktop-body-reg-medium",
  "listItem": "mc16e5a781_listItem",
  "listItemContent": "mc16e5a781_dls-typography-desktop-body-reg-medium mc16e5a781_listItemContent",
  "selected": "mc16e5a781_selected",
  "disabled": "mc16e5a781_disabled",
  "_listItemContentSlot": "mc16e5a781__listItemContentSlot"
};
var listItem$1 = "mc16e5a781_listItem";
var listItemContent = "mc16e5a781_dls-typography-desktop-body-reg-medium mc16e5a781_listItemContent";
var selected = "mc16e5a781_selected";
var disabled$3 = "mc16e5a781_disabled";
var _listItemContentSlot = "mc16e5a781__listItemContentSlot";
var styles$5 = ".mc16e5a781_dls-typography-desktop-body-reg-medium{font-family:Lab Grotesque,sans-serif;font-weight:400;text-transform:none;font-size:16px;letter-spacing:0;line-height:24px}.mc16e5a781_listItem{display:flex;outline:0}.mc16e5a781_listItemContent{border:0;border-left:6px solid transparent;color:#3e3939;flex:1 0 auto;max-width:100%;padding:12px 24px 12px 18px}a.mc16e5a781_listItemContent,button.mc16e5a781_listItemContent{cursor:pointer}a.mc16e5a781_listItemContent:focus,a.mc16e5a781_listItemContent:hover,button.mc16e5a781_listItemContent:focus,button.mc16e5a781_listItemContent:hover{background:#f5f5f5;outline:0}a.mc16e5a781_listItemContent.mc16e5a781_selected,button.mc16e5a781_listItemContent.mc16e5a781_selected{border-color:#57bbc2}a.mc16e5a781_listItemContent.mc16e5a781_disabled,button.mc16e5a781_listItemContent.mc16e5a781_disabled{color:#999;pointer-events:none}.mc16e5a781__listItemContentSlot{pointer-events:none}[data-style]{display:none}";
var listStyles$1 =
/*#__PURE__*/
Object.freeze({
  __proto__: null,
  'default': listItem,
  listItem: listItem$1,
  listItemContent: listItemContent,
  selected: selected,
  disabled: disabled$3,
  _listItemContentSlot: _listItemContentSlot,
  styles: styles$5
});

function create_fragment$3(ctx) {
  var div0;
  var t0;
  var div1;
  var raw1_value =
  /*$altStyles*/
  ctx[2].sheet("theme/".concat(
  /*theme*/
  ctx[0])) + "";
  var t1;
  var li;
  var div2;
  var slot0;
  var t2;
  var t3;
  var slot1;
  var div2_class_value;
  var li_class_value;
  return {
    c: function c() {
      div0 = element("div");
      t0 = space();
      div1 = element("div");
      t1 = space();
      li = element("li");
      div2 = element("div");
      slot0 = element("slot");
      t2 = text(
      /*formattedLabel*/
      ctx[1]);
      t3 = space();
      slot1 = element("slot");
      this.c = noop;
      attr(div0, "data-style", "");
      attr(div1, "data-style", "");
      attr(slot0, "name", "list-item-content");
      attr(div2, "class", div2_class_value = "" + (
      /*style*/
      ctx[4].is("listItemContent") + " " +
      /*$altStyles*/
      ctx[2].part("theme/".concat(
      /*theme*/
      ctx[0], "/listItemContent"))));
      attr(li, "class", li_class_value = "" + (
      /*style*/
      ctx[4].is("listItem") + " " +
      /*$altStyles*/
      ctx[2].part("theme/".concat(
      /*theme*/
      ctx[0], "/listItem"))));
      attr(li, "tabindex", "-1");
    },
    m: function m(target, anchor) {
      insert(target, div0, anchor);
      div0.innerHTML =
      /*stylesheet*/
      ctx[3];
      insert(target, t0, anchor);
      insert(target, div1, anchor);
      div1.innerHTML = raw1_value;
      insert(target, t1, anchor);
      insert(target, li, anchor);
      append(li, div2);
      append(div2, slot0);
      append(slot0, t2);
      append(div2, t3);
      append(div2, slot1);
    },
    p: function p(ctx, _ref) {
      var _ref2 = _slicedToArray(_ref, 1),
          dirty = _ref2[0];

      if (dirty &
      /*$altStyles, theme*/
      5 && raw1_value !== (raw1_value =
      /*$altStyles*/
      ctx[2].sheet("theme/".concat(
      /*theme*/
      ctx[0])) + "")) div1.innerHTML = raw1_value;
      if (dirty &
      /*formattedLabel*/
      2) set_data(t2,
      /*formattedLabel*/
      ctx[1]);

      if (dirty &
      /*$altStyles, theme*/
      5 && div2_class_value !== (div2_class_value = "" + (
      /*style*/
      ctx[4].is("listItemContent") + " " +
      /*$altStyles*/
      ctx[2].part("theme/".concat(
      /*theme*/
      ctx[0], "/listItemContent"))))) {
        attr(div2, "class", div2_class_value);
      }

      if (dirty &
      /*$altStyles, theme*/
      5 && li_class_value !== (li_class_value = "" + (
      /*style*/
      ctx[4].is("listItem") + " " +
      /*$altStyles*/
      ctx[2].part("theme/".concat(
      /*theme*/
      ctx[0], "/listItem"))))) {
        attr(li, "class", li_class_value);
      }
    },
    i: noop,
    o: noop,
    d: function d(detaching) {
      if (detaching) detach(div0);
      if (detaching) detach(t0);
      if (detaching) detach(div1);
      if (detaching) detach(t1);
      if (detaching) detach(li);
    }
  };
}

function instance$3($$self, $$props, $$invalidate) {
  var $altStyles;
  component_subscribe($$self, listStyleStore, function ($$value) {
    return $$invalidate(2, $altStyles = $$value);
  });
  var stylesheet = "<style>".concat(styles$5, "</style>");
  var style = new StyleUtilities(listStyles$1);
  var _$$props$label = $$props.label,
      label = _$$props$label === void 0 ? "" : _$$props$label;
  var _$$props$theme = $$props.theme,
      theme = _$$props$theme === void 0 ? "" : _$$props$theme;

  $$self.$set = function ($$props) {
    if ("label" in $$props) $$invalidate(5, label = $$props.label);
    if ("theme" in $$props) $$invalidate(0, theme = $$props.theme);
  };

  var formattedLabel;

  $$self.$$.update = function () {
    if ($$self.$$.dirty &
    /*label*/
    32) {
      $$invalidate(1, formattedLabel = normalizeItemLabel(label));
    }
  };

  return [theme, formattedLabel, $altStyles, stylesheet, style, label];
}

var DlsDropdowns$3 =
/*#__PURE__*/
function (_SvelteElement) {
  _inherits(DlsDropdowns, _SvelteElement);

  function DlsDropdowns(options) {
    var _this;

    _classCallCheck(this, DlsDropdowns);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DlsDropdowns).call(this));
    init(_assertThisInitialized(_this), {
      target: _this.shadowRoot
    }, instance$3, create_fragment$3, safe_not_equal, {
      label: 5,
      theme: 0
    });

    if (options) {
      if (options.target) {
        insert(options.target, _assertThisInitialized(_this), options.anchor);
      }

      if (options.props) {
        _this.$set(options.props);

        flush();
      }
    }

    return _this;
  }

  _createClass(DlsDropdowns, [{
    key: "label",
    get: function get() {
      return this.$$.ctx[5];
    },
    set: function set(label) {
      this.$set({
        label: label
      });
      flush();
    }
  }, {
    key: "theme",
    get: function get() {
      return this.$$.ctx[0];
    },
    set: function set(theme) {
      this.$set({
        theme: theme
      });
      flush();
    }
  }], [{
    key: "observedAttributes",
    get: function get() {
      return ["label", "theme"];
    }
  }]);

  return DlsDropdowns;
}(SvelteElement);

var listItemLink = {
  "dls-typography-desktop-body-reg-medium": "mc5f43b5df_dls-typography-desktop-body-reg-medium",
  "listItem": "mc5f43b5df_listItem",
  "listItemContent": "mc5f43b5df_dls-typography-desktop-body-reg-medium mc5f43b5df_listItemContent",
  "selected": "mc5f43b5df_selected",
  "disabled": "mc5f43b5df_disabled",
  "_listItemContentSlot": "mc5f43b5df__listItemContentSlot",
  "link": "mc5f43b5df_link"
};
var listItem$2 = "mc5f43b5df_listItem";
var listItemContent$1 = "mc5f43b5df_dls-typography-desktop-body-reg-medium mc5f43b5df_listItemContent";
var selected$1 = "mc5f43b5df_selected";
var disabled$4 = "mc5f43b5df_disabled";
var _listItemContentSlot$1 = "mc5f43b5df__listItemContentSlot";
var link$1 = "mc5f43b5df_link";
var styles$6 = ".mc5f43b5df_dls-typography-desktop-body-reg-medium{font-family:Lab Grotesque,sans-serif;font-weight:400;text-transform:none;font-size:16px;letter-spacing:0;line-height:24px}.mc5f43b5df_listItem{display:flex;outline:0}.mc5f43b5df_listItemContent{border:0;border-left:6px solid transparent;color:#3e3939;flex:1 0 auto;max-width:100%;padding:12px 24px 12px 18px}a.mc5f43b5df_listItemContent,button.mc5f43b5df_listItemContent{cursor:pointer}a.mc5f43b5df_listItemContent:focus,a.mc5f43b5df_listItemContent:hover,button.mc5f43b5df_listItemContent:focus,button.mc5f43b5df_listItemContent:hover{background:#f5f5f5;outline:0}a.mc5f43b5df_listItemContent.mc5f43b5df_selected,button.mc5f43b5df_listItemContent.mc5f43b5df_selected{border-color:#57bbc2}a.mc5f43b5df_listItemContent.mc5f43b5df_disabled,button.mc5f43b5df_listItemContent.mc5f43b5df_disabled{color:#999;pointer-events:none}.mc5f43b5df__listItemContentSlot{pointer-events:none}[data-style]{display:none}.mc5f43b5df_link{text-decoration:none}";
var listItemLinkStyles =
/*#__PURE__*/
Object.freeze({
  __proto__: null,
  'default': listItemLink,
  listItem: listItem$2,
  listItemContent: listItemContent$1,
  selected: selected$1,
  disabled: disabled$4,
  _listItemContentSlot: _listItemContentSlot$1,
  link: link$1,
  styles: styles$6
});

function create_fragment$4(ctx) {
  var div0;
  var t0;
  var div1;
  var raw1_value =
  /*$altStyles*/
  ctx[3].sheet("theme/".concat(
  /*theme*/
  ctx[2])) + "";
  var t1;
  var li;
  var a;
  var div2;
  var slot0;
  var t2;
  var t3;
  var slot1;
  var div2_class_value;
  var a_class_value;
  var li_class_value;
  var initialize_action;
  var dispose;
  return {
    c: function c() {
      div0 = element("div");
      t0 = space();
      div1 = element("div");
      t1 = space();
      li = element("li");
      a = element("a");
      div2 = element("div");
      slot0 = element("slot");
      t2 = text(
      /*formattedLabel*/
      ctx[4]);
      t3 = space();
      slot1 = element("slot");
      this.c = noop;
      attr(div0, "data-style", "");
      attr(div1, "data-style", "");
      attr(slot0, "name", "list-item-content");
      attr(div2, "class", div2_class_value =
      /*style*/
      ctx[8].is("_listItemContentSlot"));
      attr(a, "class", a_class_value = "" + (
      /*style*/
      ctx[8].are("listItemContent", "link") + " " +
      /*$altStyles*/
      ctx[3].part("theme/".concat(
      /*theme*/
      ctx[2], "/listItemContent")) + " " +
      /*variations*/
      ctx[6]));
      attr(a, "href",
      /*href*/
      ctx[0]);
      attr(a, "target",
      /*target*/
      ctx[1]);
      attr(a, "tabindex",
      /*tabindex*/
      ctx[5]);
      attr(li, "class", li_class_value = "" + (
      /*style*/
      ctx[8].is("listItem") + " " +
      /*$altStyles*/
      ctx[3].part("theme/".concat(
      /*theme*/
      ctx[2], "/listItem")) + " " +
      /*variations*/
      ctx[6]));
      attr(li, "data-hook", "dls-list-item-link");
      attr(li, "tabindex", "-1");
    },
    m: function m(target, anchor) {
      insert(target, div0, anchor);
      div0.innerHTML =
      /*stylesheet*/
      ctx[7];
      insert(target, t0, anchor);
      insert(target, div1, anchor);
      div1.innerHTML = raw1_value;
      insert(target, t1, anchor);
      insert(target, li, anchor);
      append(li, a);
      append(a, div2);
      append(div2, slot0);
      append(slot0, t2);
      append(div2, t3);
      append(div2, slot1);
      dispose = [listen(slot0, "slotchange",
      /*getSlottedChildren*/
      ctx[11]), listen(slot1, "slotchange",
      /*getSlottedChildren*/
      ctx[11]), listen(a, "click",
      /*dispatchInputEvent*/
      ctx[10]), action_destroyer(initialize_action =
      /*initialize*/
      ctx[9].call(null, li))];
    },
    p: function p(ctx, _ref) {
      var _ref2 = _slicedToArray(_ref, 1),
          dirty = _ref2[0];

      if (dirty &
      /*$altStyles, theme*/
      12 && raw1_value !== (raw1_value =
      /*$altStyles*/
      ctx[3].sheet("theme/".concat(
      /*theme*/
      ctx[2])) + "")) div1.innerHTML = raw1_value;
      if (dirty &
      /*formattedLabel*/
      16) set_data(t2,
      /*formattedLabel*/
      ctx[4]);

      if (dirty &
      /*$altStyles, theme, variations*/
      76 && a_class_value !== (a_class_value = "" + (
      /*style*/
      ctx[8].are("listItemContent", "link") + " " +
      /*$altStyles*/
      ctx[3].part("theme/".concat(
      /*theme*/
      ctx[2], "/listItemContent")) + " " +
      /*variations*/
      ctx[6]))) {
        attr(a, "class", a_class_value);
      }

      if (dirty &
      /*href*/
      1) {
        attr(a, "href",
        /*href*/
        ctx[0]);
      }

      if (dirty &
      /*target*/
      2) {
        attr(a, "target",
        /*target*/
        ctx[1]);
      }

      if (dirty &
      /*tabindex*/
      32) {
        attr(a, "tabindex",
        /*tabindex*/
        ctx[5]);
      }

      if (dirty &
      /*$altStyles, theme, variations*/
      76 && li_class_value !== (li_class_value = "" + (
      /*style*/
      ctx[8].is("listItem") + " " +
      /*$altStyles*/
      ctx[3].part("theme/".concat(
      /*theme*/
      ctx[2], "/listItem")) + " " +
      /*variations*/
      ctx[6]))) {
        attr(li, "class", li_class_value);
      }
    },
    i: noop,
    o: noop,
    d: function d(detaching) {
      if (detaching) detach(div0);
      if (detaching) detach(t0);
      if (detaching) detach(div1);
      if (detaching) detach(t1);
      if (detaching) detach(li);
      run_all(dispose);
    }
  };
}

function instance$4($$self, $$props, $$invalidate) {
  var $altStyles;
  component_subscribe($$self, listStyleStore, function ($$value) {
    return $$invalidate(3, $altStyles = $$value);
  });
  var stylesheet = "<style>".concat(styles$6, "</style>");
  var style = new StyleUtilities(listItemLinkStyles);
  var normalizedTriggerLabel; // Get host for input/change/selection support

  var dispatchInputEventDetail,
      hostElement,
      updateSelection = function updateSelection() {};

  function initialize(node) {
    $$invalidate(19, hostElement = node.parentNode.host);
    $$invalidate(20, updateSelection = getUpdateItemSelection(hostElement));
  } // Support link usage and selection


  function dispatchInputEvent() {
    dispatchInputEventDetail();
  } // Support slotted labels without extra triggerlabel when plain text


  var slottedChildren = [];
  var getSlottedChildren = getSlotChangeHandler(undefined, function onAfterHandle(event, newSlottedChildren) {
    $$invalidate(21, slottedChildren = newSlottedChildren);
  }, filterNodes); // Style and custom themes

  function getVariants(disabled, selected, theme) {
    var variants = [disabled && style.is("disabled"), disabled && $altStyles.variant("theme/".concat(theme, "/disabled")), selected && style.is("selected"), selected && $altStyles.variant("theme/".concat(theme, "/selected"))].filter(Boolean).join(" ");
    return variants.length ? variants : "";
  }

  var _$$props$_valuelist = $$props._valuelist,
      _valuelist = _$$props$_valuelist === void 0 ? [] : _$$props$_valuelist;

  var _$$props$disabled = $$props.disabled,
      disabled = _$$props$disabled === void 0 ? false : _$$props$disabled;
  var _$$props$href = $$props.href,
      href = _$$props$href === void 0 ? "" : _$$props$href;
  var _$$props$label = $$props.label,
      label = _$$props$label === void 0 ? "" : _$$props$label;
  var _$$props$selected = $$props.selected,
      selected = _$$props$selected === void 0 ? false : _$$props$selected;
  var _$$props$target = $$props.target,
      target = _$$props$target === void 0 ? "" : _$$props$target;
  var _$$props$theme = $$props.theme,
      theme = _$$props$theme === void 0 ? "" : _$$props$theme;
  var _$$props$triggerlabel = $$props.triggerlabel,
      triggerlabel = _$$props$triggerlabel === void 0 ? "" : _$$props$triggerlabel;

  $$self.$set = function ($$props) {
    if ("_valuelist" in $$props) $$invalidate(12, _valuelist = $$props._valuelist);
    if ("disabled" in $$props) $$invalidate(13, disabled = $$props.disabled);
    if ("href" in $$props) $$invalidate(0, href = $$props.href);
    if ("label" in $$props) $$invalidate(14, label = $$props.label);
    if ("selected" in $$props) $$invalidate(15, selected = $$props.selected);
    if ("target" in $$props) $$invalidate(1, target = $$props.target);
    if ("theme" in $$props) $$invalidate(2, theme = $$props.theme);
    if ("triggerlabel" in $$props) $$invalidate(16, triggerlabel = $$props.triggerlabel);
  };

  var formattedLabel;
  var tabindex;
  var variations;

  $$self.$$.update = function () {
    if ($$self.$$.dirty &
    /*label*/
    16384) {
      $$invalidate(4, formattedLabel = normalizeItemLabel(label));
    }

    if ($$self.$$.dirty &
    /*slottedChildren, triggerlabel, formattedLabel*/
    2162704) {
      // Label precedence: triggerlabel > slot > label
      $$invalidate(17, normalizedTriggerLabel = normalizeTriggerLabel(slottedChildren, triggerlabel, formattedLabel));
    }

    if ($$self.$$.dirty &
    /*hostElement, normalizedTriggerLabel*/
    655360) {
      dispatchInputEventDetail = getInputDispatcher(hostElement, normalizedTriggerLabel, normalizedTriggerLabel);
    }

    if ($$self.$$.dirty &
    /*selected, normalizedTriggerLabel*/
    163840) {
      // IE was occasionally transmitting initial state without value
      if (selected && normalizedTriggerLabel) {
        dispatchInputEvent();
      }
    }

    if ($$self.$$.dirty &
    /*disabled*/
    8192) {
      $$invalidate(5, tabindex = disabled ? -1 : 0);
    }

    if ($$self.$$.dirty &
    /*updateSelection, _valuelist, normalizedTriggerLabel*/
    1183744) {
      updateSelection(_valuelist, normalizedTriggerLabel);
    }

    if ($$self.$$.dirty &
    /*disabled, selected, theme*/
    40964) {
      $$invalidate(6, variations = getVariants(disabled, selected, theme));
    }
  };

  return [href, target, theme, $altStyles, formattedLabel, tabindex, variations, stylesheet, style, initialize, dispatchInputEvent, getSlottedChildren, _valuelist, disabled, label, selected, triggerlabel];
}

var DlsDropdowns$4 =
/*#__PURE__*/
function (_SvelteElement) {
  _inherits(DlsDropdowns, _SvelteElement);

  function DlsDropdowns(options) {
    var _this;

    _classCallCheck(this, DlsDropdowns);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DlsDropdowns).call(this));
    init(_assertThisInitialized(_this), {
      target: _this.shadowRoot
    }, instance$4, create_fragment$4, safe_not_equal, {
      _valuelist: 12,
      disabled: 13,
      href: 0,
      label: 14,
      selected: 15,
      target: 1,
      theme: 2,
      triggerlabel: 16
    });

    if (options) {
      if (options.target) {
        insert(options.target, _assertThisInitialized(_this), options.anchor);
      }

      if (options.props) {
        _this.$set(options.props);

        flush();
      }
    }

    return _this;
  }

  _createClass(DlsDropdowns, [{
    key: "_valuelist",
    get: function get() {
      return this.$$.ctx[12];
    },
    set: function set(_valuelist) {
      this.$set({
        _valuelist: _valuelist
      });
      flush();
    }
  }, {
    key: "disabled",
    get: function get() {
      return this.$$.ctx[13];
    },
    set: function set(disabled) {
      this.$set({
        disabled: disabled
      });
      flush();
    }
  }, {
    key: "href",
    get: function get() {
      return this.$$.ctx[0];
    },
    set: function set(href) {
      this.$set({
        href: href
      });
      flush();
    }
  }, {
    key: "label",
    get: function get() {
      return this.$$.ctx[14];
    },
    set: function set(label) {
      this.$set({
        label: label
      });
      flush();
    }
  }, {
    key: "selected",
    get: function get() {
      return this.$$.ctx[15];
    },
    set: function set(selected) {
      this.$set({
        selected: selected
      });
      flush();
    }
  }, {
    key: "target",
    get: function get() {
      return this.$$.ctx[1];
    },
    set: function set(target) {
      this.$set({
        target: target
      });
      flush();
    }
  }, {
    key: "theme",
    get: function get() {
      return this.$$.ctx[2];
    },
    set: function set(theme) {
      this.$set({
        theme: theme
      });
      flush();
    }
  }, {
    key: "triggerlabel",
    get: function get() {
      return this.$$.ctx[16];
    },
    set: function set(triggerlabel) {
      this.$set({
        triggerlabel: triggerlabel
      });
      flush();
    }
  }], [{
    key: "observedAttributes",
    get: function get() {
      return ["_valuelist", "disabled", "href", "label", "selected", "target", "theme", "triggerlabel"];
    }
  }]);

  return DlsDropdowns;
}(SvelteElement);

var listItemButton = {
  "dls-typography-desktop-body-reg-medium": "mc56bb6130_dls-typography-desktop-body-reg-medium",
  "listItem": "mc56bb6130_listItem",
  "listItemContent": "mc56bb6130_dls-typography-desktop-body-reg-medium mc56bb6130_listItemContent",
  "selected": "mc56bb6130_selected",
  "disabled": "mc56bb6130_disabled",
  "_listItemContentSlot": "mc56bb6130__listItemContentSlot",
  "button": "mc56bb6130_button"
};
var listItem$3 = "mc56bb6130_listItem";
var listItemContent$2 = "mc56bb6130_dls-typography-desktop-body-reg-medium mc56bb6130_listItemContent";
var selected$2 = "mc56bb6130_selected";
var disabled$5 = "mc56bb6130_disabled";
var _listItemContentSlot$2 = "mc56bb6130__listItemContentSlot";
var button = "mc56bb6130_button";
var styles$7 = ".mc56bb6130_dls-typography-desktop-body-reg-medium{font-family:Lab Grotesque,sans-serif;font-weight:400;text-transform:none;font-size:16px;letter-spacing:0;line-height:24px}.mc56bb6130_listItem{display:flex;outline:0}.mc56bb6130_listItemContent{border:0;border-left:6px solid transparent;color:#3e3939;flex:1 0 auto;max-width:100%;padding:12px 24px 12px 18px}a.mc56bb6130_listItemContent,button.mc56bb6130_listItemContent{cursor:pointer}a.mc56bb6130_listItemContent:focus,a.mc56bb6130_listItemContent:hover,button.mc56bb6130_listItemContent:focus,button.mc56bb6130_listItemContent:hover{background:#f5f5f5;outline:0}a.mc56bb6130_listItemContent.mc56bb6130_selected,button.mc56bb6130_listItemContent.mc56bb6130_selected{border-color:#57bbc2}a.mc56bb6130_listItemContent.mc56bb6130_disabled,button.mc56bb6130_listItemContent.mc56bb6130_disabled{color:#999;pointer-events:none}.mc56bb6130__listItemContentSlot{pointer-events:none}[data-style]{display:none}.mc56bb6130_button{background:transparent;border-radius:0;margin:0;text-align:left}";
var listItemButtonStyles =
/*#__PURE__*/
Object.freeze({
  __proto__: null,
  'default': listItemButton,
  listItem: listItem$3,
  listItemContent: listItemContent$2,
  selected: selected$2,
  disabled: disabled$5,
  _listItemContentSlot: _listItemContentSlot$2,
  button: button,
  styles: styles$7
});

function create_fragment$5(ctx) {
  var div0;
  var t0;
  var div1;
  var raw1_value =
  /*$altStyles*/
  ctx[2].sheet("theme/".concat(
  /*theme*/
  ctx[0])) + "";
  var t1;
  var li;
  var button;
  var div2;
  var slot0;
  var t2;
  var t3;
  var slot1;
  var div2_class_value;
  var button_class_value;
  var li_class_value;
  var initialize_action;
  var dispose;
  return {
    c: function c() {
      div0 = element("div");
      t0 = space();
      div1 = element("div");
      t1 = space();
      li = element("li");
      button = element("button");
      div2 = element("div");
      slot0 = element("slot");
      t2 = text(
      /*formattedLabel*/
      ctx[3]);
      t3 = space();
      slot1 = element("slot");
      this.c = noop;
      attr(div0, "data-style", "");
      attr(div1, "data-style", "");
      attr(slot0, "name", "list-item-content");
      attr(div2, "class", div2_class_value =
      /*style*/
      ctx[7].is("_listItemContentSlot"));
      attr(button, "class", button_class_value = "" + (
      /*style*/
      ctx[7].are("listItemContent", "button") + " " +
      /*$altStyles*/
      ctx[2].part("theme/".concat(
      /*theme*/
      ctx[0], "/listItemContent")) + " " +
      /*variations*/
      ctx[5]));
      button.value =
      /*value*/
      ctx[1];
      attr(button, "tabindex",
      /*tabindex*/
      ctx[4]);
      attr(li, "class", li_class_value = "" + (
      /*style*/
      ctx[7].is("listItem") + " " +
      /*$altStyles*/
      ctx[2].part("theme/".concat(
      /*theme*/
      ctx[0], "/listItem")) + " " +
      /*variations*/
      ctx[5]));
      attr(li, "data-hook", "dls-list-item-button");
      attr(li, "tabindex", "-1");
    },
    m: function m(target, anchor) {
      insert(target, div0, anchor);
      div0.innerHTML =
      /*stylesheet*/
      ctx[6];
      insert(target, t0, anchor);
      insert(target, div1, anchor);
      div1.innerHTML = raw1_value;
      insert(target, t1, anchor);
      insert(target, li, anchor);
      append(li, button);
      append(button, div2);
      append(div2, slot0);
      append(slot0, t2);
      append(div2, t3);
      append(div2, slot1);
      dispose = [listen(slot0, "slotchange",
      /*getSlottedChildren*/
      ctx[10]), listen(slot1, "slotchange",
      /*getSlottedChildren*/
      ctx[10]), listen(button, "click",
      /*dispatchInputEvent*/
      ctx[9]), action_destroyer(initialize_action =
      /*initialize*/
      ctx[8].call(null, li))];
    },
    p: function p(ctx, _ref) {
      var _ref2 = _slicedToArray(_ref, 1),
          dirty = _ref2[0];

      if (dirty &
      /*$altStyles, theme*/
      5 && raw1_value !== (raw1_value =
      /*$altStyles*/
      ctx[2].sheet("theme/".concat(
      /*theme*/
      ctx[0])) + "")) div1.innerHTML = raw1_value;
      if (dirty &
      /*formattedLabel*/
      8) set_data(t2,
      /*formattedLabel*/
      ctx[3]);

      if (dirty &
      /*$altStyles, theme, variations*/
      37 && button_class_value !== (button_class_value = "" + (
      /*style*/
      ctx[7].are("listItemContent", "button") + " " +
      /*$altStyles*/
      ctx[2].part("theme/".concat(
      /*theme*/
      ctx[0], "/listItemContent")) + " " +
      /*variations*/
      ctx[5]))) {
        attr(button, "class", button_class_value);
      }

      if (dirty &
      /*value*/
      2) {
        button.value =
        /*value*/
        ctx[1];
      }

      if (dirty &
      /*tabindex*/
      16) {
        attr(button, "tabindex",
        /*tabindex*/
        ctx[4]);
      }

      if (dirty &
      /*$altStyles, theme, variations*/
      37 && li_class_value !== (li_class_value = "" + (
      /*style*/
      ctx[7].is("listItem") + " " +
      /*$altStyles*/
      ctx[2].part("theme/".concat(
      /*theme*/
      ctx[0], "/listItem")) + " " +
      /*variations*/
      ctx[5]))) {
        attr(li, "class", li_class_value);
      }
    },
    i: noop,
    o: noop,
    d: function d(detaching) {
      if (detaching) detach(div0);
      if (detaching) detach(t0);
      if (detaching) detach(div1);
      if (detaching) detach(t1);
      if (detaching) detach(li);
      run_all(dispose);
    }
  };
}

function instance$5($$self, $$props, $$invalidate) {
  var $altStyles;
  component_subscribe($$self, listStyleStore, function ($$value) {
    return $$invalidate(2, $altStyles = $$value);
  });
  var stylesheet = "<style>".concat(styles$7, "</style>");
  var style = new StyleUtilities(listItemButtonStyles);
  var normalizedTriggerLabel; // Get host for input/change/selection support

  var dispatchInputEventDetail,
      hostElement,
      updateSelection = function updateSelection() {};

  function initialize(node) {
    $$invalidate(18, hostElement = node.parentNode.host);
    $$invalidate(19, updateSelection = getUpdateItemSelection(hostElement));
  } // Support button usage and selection


  function dispatchInputEvent() {
    dispatchInputEventDetail();
  } // Support slotted labels without extra triggerlabel when plain text


  var slottedChildren = [];
  var getSlottedChildren = getSlotChangeHandler(undefined, function onAfterHandle(event, newSlottedChildren) {
    $$invalidate(20, slottedChildren = newSlottedChildren);
  }, filterNodes); // Style and custom themes

  function getVariants(disabled, selected, theme) {
    var variants = [disabled && style.is("disabled"), disabled && $altStyles.variant("theme/".concat(theme, "/disabled")), selected && style.is("selected"), selected && $altStyles.variant("theme/".concat(theme, "/selected"))].filter(Boolean).join(" ");
    return variants.length ? variants : "";
  }

  var _$$props$_valuelist = $$props._valuelist,
      _valuelist = _$$props$_valuelist === void 0 ? [] : _$$props$_valuelist;

  var _$$props$disabled = $$props.disabled,
      disabled = _$$props$disabled === void 0 ? false : _$$props$disabled;
  var _$$props$label = $$props.label,
      label = _$$props$label === void 0 ? "" : _$$props$label;
  var _$$props$selected = $$props.selected,
      selected = _$$props$selected === void 0 ? false : _$$props$selected;
  var _$$props$theme = $$props.theme,
      theme = _$$props$theme === void 0 ? "" : _$$props$theme;
  var _$$props$triggerlabel = $$props.triggerlabel,
      triggerlabel = _$$props$triggerlabel === void 0 ? "" : _$$props$triggerlabel;
  var _$$props$value = $$props.value,
      value = _$$props$value === void 0 ? "" : _$$props$value;

  $$self.$set = function ($$props) {
    if ("_valuelist" in $$props) $$invalidate(11, _valuelist = $$props._valuelist);
    if ("disabled" in $$props) $$invalidate(12, disabled = $$props.disabled);
    if ("label" in $$props) $$invalidate(13, label = $$props.label);
    if ("selected" in $$props) $$invalidate(14, selected = $$props.selected);
    if ("theme" in $$props) $$invalidate(0, theme = $$props.theme);
    if ("triggerlabel" in $$props) $$invalidate(15, triggerlabel = $$props.triggerlabel);
    if ("value" in $$props) $$invalidate(1, value = $$props.value);
  };

  var formattedLabel;
  var tabindex;
  var variations;

  $$self.$$.update = function () {
    if ($$self.$$.dirty &
    /*label*/
    8192) {
      $$invalidate(3, formattedLabel = normalizeItemLabel(label));
    }

    if ($$self.$$.dirty &
    /*slottedChildren, triggerlabel, formattedLabel*/
    1081352) {
      // Label precedence: triggerlabel > slot > label
      $$invalidate(16, normalizedTriggerLabel = normalizeTriggerLabel(slottedChildren, triggerlabel, formattedLabel));
    }

    if ($$self.$$.dirty &
    /*hostElement, normalizedTriggerLabel, value*/
    327682) {
      dispatchInputEventDetail = getInputDispatcher(hostElement, normalizedTriggerLabel, value);
    }

    if ($$self.$$.dirty &
    /*selected, value, normalizedTriggerLabel*/
    81922) {
      // IE was occasionally transmitting initial state without value
      if (selected && value && normalizedTriggerLabel) {
        dispatchInputEvent();
      }
    }

    if ($$self.$$.dirty &
    /*disabled*/
    4096) {
      $$invalidate(4, tabindex = disabled ? -1 : 0);
    }

    if ($$self.$$.dirty &
    /*updateSelection, _valuelist, value*/
    526338) {
      updateSelection(_valuelist, value);
    }

    if ($$self.$$.dirty &
    /*disabled, selected, theme*/
    20481) {
      $$invalidate(5, variations = getVariants(disabled, selected, theme));
    }
  };

  return [theme, value, $altStyles, formattedLabel, tabindex, variations, stylesheet, style, initialize, dispatchInputEvent, getSlottedChildren, _valuelist, disabled, label, selected, triggerlabel];
}

var DlsDropdowns$5 =
/*#__PURE__*/
function (_SvelteElement) {
  _inherits(DlsDropdowns, _SvelteElement);

  function DlsDropdowns(options) {
    var _this;

    _classCallCheck(this, DlsDropdowns);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DlsDropdowns).call(this));
    init(_assertThisInitialized(_this), {
      target: _this.shadowRoot
    }, instance$5, create_fragment$5, safe_not_equal, {
      _valuelist: 11,
      disabled: 12,
      label: 13,
      selected: 14,
      theme: 0,
      triggerlabel: 15,
      value: 1
    });

    if (options) {
      if (options.target) {
        insert(options.target, _assertThisInitialized(_this), options.anchor);
      }

      if (options.props) {
        _this.$set(options.props);

        flush();
      }
    }

    return _this;
  }

  _createClass(DlsDropdowns, [{
    key: "_valuelist",
    get: function get() {
      return this.$$.ctx[11];
    },
    set: function set(_valuelist) {
      this.$set({
        _valuelist: _valuelist
      });
      flush();
    }
  }, {
    key: "disabled",
    get: function get() {
      return this.$$.ctx[12];
    },
    set: function set(disabled) {
      this.$set({
        disabled: disabled
      });
      flush();
    }
  }, {
    key: "label",
    get: function get() {
      return this.$$.ctx[13];
    },
    set: function set(label) {
      this.$set({
        label: label
      });
      flush();
    }
  }, {
    key: "selected",
    get: function get() {
      return this.$$.ctx[14];
    },
    set: function set(selected) {
      this.$set({
        selected: selected
      });
      flush();
    }
  }, {
    key: "theme",
    get: function get() {
      return this.$$.ctx[0];
    },
    set: function set(theme) {
      this.$set({
        theme: theme
      });
      flush();
    }
  }, {
    key: "triggerlabel",
    get: function get() {
      return this.$$.ctx[15];
    },
    set: function set(triggerlabel) {
      this.$set({
        triggerlabel: triggerlabel
      });
      flush();
    }
  }, {
    key: "value",
    get: function get() {
      return this.$$.ctx[1];
    },
    set: function set(value) {
      this.$set({
        value: value
      });
      flush();
    }
  }], [{
    key: "observedAttributes",
    get: function get() {
      return ["_valuelist", "disabled", "label", "selected", "theme", "triggerlabel", "value"];
    }
  }]);

  return DlsDropdowns;
}(SvelteElement);

var listItemDivider = {
  "listItem": "mcd88e51ce_listItem",
  "divider": "mcd88e51ce_divider"
};
var listItem$4 = "mcd88e51ce_listItem";
var divider = "mcd88e51ce_divider";
var styles$8 = ".mcd88e51ce_listItem{display:block;outline:0}.mcd88e51ce_divider{background:#e0e3e4;cursor:default;height:1px;margin:8px 0;padding:0}[data-style]{display:none}";
var dividerStyles =
/*#__PURE__*/
Object.freeze({
  __proto__: null,
  'default': listItemDivider,
  listItem: listItem$4,
  divider: divider,
  styles: styles$8
});

function create_fragment$6(ctx) {
  var div0;
  var t0;
  var div1;
  var raw1_value =
  /*$altStyles*/
  ctx[1].sheet("theme/".concat(
  /*theme*/
  ctx[0])) + "";
  var t1;
  var li;
  var div2;
  var div2_class_value;
  var li_class_value;
  return {
    c: function c() {
      div0 = element("div");
      t0 = space();
      div1 = element("div");
      t1 = space();
      li = element("li");
      div2 = element("div");
      this.c = noop;
      attr(div0, "data-style", "");
      attr(div1, "data-style", "");
      attr(div2, "class", div2_class_value = "" + (
      /*style*/
      ctx[3].is("divider") + " " +
      /*$altStyles*/
      ctx[1].part("theme/".concat(
      /*theme*/
      ctx[0], "/listItemContent")) + " " +
      /*$altStyles*/
      ctx[1].variant("theme/".concat(
      /*theme*/
      ctx[0], "/divider"))));
      attr(li, "class", li_class_value = "" + (
      /*style*/
      ctx[3].is("listItem") + " " +
      /*$altStyles*/
      ctx[1].part("theme/".concat(
      /*theme*/
      ctx[0], "/listItem"))));
      attr(li, "tabindex", "-1");
    },
    m: function m(target, anchor) {
      insert(target, div0, anchor);
      div0.innerHTML =
      /*stylesheet*/
      ctx[2];
      insert(target, t0, anchor);
      insert(target, div1, anchor);
      div1.innerHTML = raw1_value;
      insert(target, t1, anchor);
      insert(target, li, anchor);
      append(li, div2);
    },
    p: function p(ctx, _ref) {
      var _ref2 = _slicedToArray(_ref, 1),
          dirty = _ref2[0];

      if (dirty &
      /*$altStyles, theme*/
      3 && raw1_value !== (raw1_value =
      /*$altStyles*/
      ctx[1].sheet("theme/".concat(
      /*theme*/
      ctx[0])) + "")) div1.innerHTML = raw1_value;

      if (dirty &
      /*$altStyles, theme*/
      3 && div2_class_value !== (div2_class_value = "" + (
      /*style*/
      ctx[3].is("divider") + " " +
      /*$altStyles*/
      ctx[1].part("theme/".concat(
      /*theme*/
      ctx[0], "/listItemContent")) + " " +
      /*$altStyles*/
      ctx[1].variant("theme/".concat(
      /*theme*/
      ctx[0], "/divider"))))) {
        attr(div2, "class", div2_class_value);
      }

      if (dirty &
      /*$altStyles, theme*/
      3 && li_class_value !== (li_class_value = "" + (
      /*style*/
      ctx[3].is("listItem") + " " +
      /*$altStyles*/
      ctx[1].part("theme/".concat(
      /*theme*/
      ctx[0], "/listItem"))))) {
        attr(li, "class", li_class_value);
      }
    },
    i: noop,
    o: noop,
    d: function d(detaching) {
      if (detaching) detach(div0);
      if (detaching) detach(t0);
      if (detaching) detach(div1);
      if (detaching) detach(t1);
      if (detaching) detach(li);
    }
  };
}

function instance$6($$self, $$props, $$invalidate) {
  var $altStyles;
  component_subscribe($$self, listStyleStore, function ($$value) {
    return $$invalidate(1, $altStyles = $$value);
  });
  var stylesheet = "<style>".concat(styles$8, "</style>");
  var style = new StyleUtilities(dividerStyles);
  var _$$props$theme = $$props.theme,
      theme = _$$props$theme === void 0 ? "" : _$$props$theme;

  $$self.$set = function ($$props) {
    if ("theme" in $$props) $$invalidate(0, theme = $$props.theme);
  };

  return [theme, $altStyles, stylesheet, style];
}

var DlsDropdowns$6 =
/*#__PURE__*/
function (_SvelteElement) {
  _inherits(DlsDropdowns, _SvelteElement);

  function DlsDropdowns(options) {
    var _this;

    _classCallCheck(this, DlsDropdowns);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DlsDropdowns).call(this));
    init(_assertThisInitialized(_this), {
      target: _this.shadowRoot
    }, instance$6, create_fragment$6, safe_not_equal, {
      theme: 0
    });

    if (options) {
      if (options.target) {
        insert(options.target, _assertThisInitialized(_this), options.anchor);
      }

      if (options.props) {
        _this.$set(options.props);

        flush();
      }
    }

    return _this;
  }

  _createClass(DlsDropdowns, [{
    key: "theme",
    get: function get() {
      return this.$$.ctx[0];
    },
    set: function set(theme) {
      this.$set({
        theme: theme
      });
      flush();
    }
  }], [{
    key: "observedAttributes",
    get: function get() {
      return ["theme"];
    }
  }]);

  return DlsDropdowns;
}(SvelteElement);

var listItemCategory = {
  "dls-typography-desktop-uppercase-med-medium": "mc068744fe_dls-typography-desktop-uppercase-med-medium",
  "listItem": "mc068744fe_listItem",
  "category": "mc068744fe_dls-typography-desktop-uppercase-med-medium mc068744fe_category"
};
var listItem$5 = "mc068744fe_listItem";
var category = "mc068744fe_dls-typography-desktop-uppercase-med-medium mc068744fe_category";
var styles$9 = ".mc068744fe_dls-typography-desktop-uppercase-med-medium{font-family:Lab Grotesque,sans-serif;font-weight:500;text-transform:uppercase;font-size:12px;letter-spacing:1.399999976158142px;line-height:18px}.mc068744fe_listItem{display:flex;outline:0}.mc068744fe_category{color:#706f6e;cursor:default;padding:12px 24px 8px}[data-style]{display:none}";
var categoryStyles =
/*#__PURE__*/
Object.freeze({
  __proto__: null,
  'default': listItemCategory,
  listItem: listItem$5,
  category: category,
  styles: styles$9
});

function create_fragment$7(ctx) {
  var div0;
  var t0;
  var div1;
  var raw1_value =
  /*$altStyles*/
  ctx[2].sheet("theme/".concat(
  /*theme*/
  ctx[0])) + "";
  var t1;
  var li;
  var span;
  var slot0;
  var t2;
  var t3;
  var slot1;
  var span_class_value;
  var li_class_value;
  return {
    c: function c() {
      div0 = element("div");
      t0 = space();
      div1 = element("div");
      t1 = space();
      li = element("li");
      span = element("span");
      slot0 = element("slot");
      t2 = text(
      /*formattedName*/
      ctx[1]);
      t3 = space();
      slot1 = element("slot");
      this.c = noop;
      attr(div0, "data-style", "");
      attr(div1, "data-style", "");
      attr(slot0, "name", "list-item-content");
      attr(span, "class", span_class_value = "" + (
      /*style*/
      ctx[4].is("category") + " " +
      /*$altStyles*/
      ctx[2].part("theme/".concat(
      /*theme*/
      ctx[0], "/listItemContent")) + " " +
      /*$altStyles*/
      ctx[2].variant("theme/".concat(
      /*theme*/
      ctx[0], "/category"))));
      attr(li, "class", li_class_value = "" + (
      /*style*/
      ctx[4].is("listItem") + " " +
      /*$altStyles*/
      ctx[2].part("theme/".concat(
      /*theme*/
      ctx[0], "/listItem"))));
      attr(li, "tabindex", "-1");
    },
    m: function m(target, anchor) {
      insert(target, div0, anchor);
      div0.innerHTML =
      /*stylesheet*/
      ctx[3];
      insert(target, t0, anchor);
      insert(target, div1, anchor);
      div1.innerHTML = raw1_value;
      insert(target, t1, anchor);
      insert(target, li, anchor);
      append(li, span);
      append(span, slot0);
      append(slot0, t2);
      append(span, t3);
      append(span, slot1);
    },
    p: function p(ctx, _ref) {
      var _ref2 = _slicedToArray(_ref, 1),
          dirty = _ref2[0];

      if (dirty &
      /*$altStyles, theme*/
      5 && raw1_value !== (raw1_value =
      /*$altStyles*/
      ctx[2].sheet("theme/".concat(
      /*theme*/
      ctx[0])) + "")) div1.innerHTML = raw1_value;
      if (dirty &
      /*formattedName*/
      2) set_data(t2,
      /*formattedName*/
      ctx[1]);

      if (dirty &
      /*$altStyles, theme*/
      5 && span_class_value !== (span_class_value = "" + (
      /*style*/
      ctx[4].is("category") + " " +
      /*$altStyles*/
      ctx[2].part("theme/".concat(
      /*theme*/
      ctx[0], "/listItemContent")) + " " +
      /*$altStyles*/
      ctx[2].variant("theme/".concat(
      /*theme*/
      ctx[0], "/category"))))) {
        attr(span, "class", span_class_value);
      }

      if (dirty &
      /*$altStyles, theme*/
      5 && li_class_value !== (li_class_value = "" + (
      /*style*/
      ctx[4].is("listItem") + " " +
      /*$altStyles*/
      ctx[2].part("theme/".concat(
      /*theme*/
      ctx[0], "/listItem"))))) {
        attr(li, "class", li_class_value);
      }
    },
    i: noop,
    o: noop,
    d: function d(detaching) {
      if (detaching) detach(div0);
      if (detaching) detach(t0);
      if (detaching) detach(div1);
      if (detaching) detach(t1);
      if (detaching) detach(li);
    }
  };
}

function instance$7($$self, $$props, $$invalidate) {
  var $altStyles;
  component_subscribe($$self, listStyleStore, function ($$value) {
    return $$invalidate(2, $altStyles = $$value);
  });
  var stylesheet = "<style>".concat(styles$9, "</style>");
  var style = new StyleUtilities(categoryStyles);
  var _$$props$name = $$props.name,
      name = _$$props$name === void 0 ? "" : _$$props$name;
  var _$$props$theme = $$props.theme,
      theme = _$$props$theme === void 0 ? "" : _$$props$theme;

  $$self.$set = function ($$props) {
    if ("name" in $$props) $$invalidate(5, name = $$props.name);
    if ("theme" in $$props) $$invalidate(0, theme = $$props.theme);
  };

  var formattedName;

  $$self.$$.update = function () {
    if ($$self.$$.dirty &
    /*name*/
    32) {
      $$invalidate(1, formattedName = normalizeItemLabel(name));
    }
  };

  return [theme, formattedName, $altStyles, stylesheet, style, name];
}

var DlsDropdowns$7 =
/*#__PURE__*/
function (_SvelteElement) {
  _inherits(DlsDropdowns, _SvelteElement);

  function DlsDropdowns(options) {
    var _this;

    _classCallCheck(this, DlsDropdowns);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DlsDropdowns).call(this));
    init(_assertThisInitialized(_this), {
      target: _this.shadowRoot
    }, instance$7, create_fragment$7, safe_not_equal, {
      name: 5,
      theme: 0
    });

    if (options) {
      if (options.target) {
        insert(options.target, _assertThisInitialized(_this), options.anchor);
      }

      if (options.props) {
        _this.$set(options.props);

        flush();
      }
    }

    return _this;
  }

  _createClass(DlsDropdowns, [{
    key: "name",
    get: function get() {
      return this.$$.ctx[5];
    },
    set: function set(name) {
      this.$set({
        name: name
      });
      flush();
    }
  }, {
    key: "theme",
    get: function get() {
      return this.$$.ctx[0];
    },
    set: function set(theme) {
      this.$set({
        theme: theme
      });
      flush();
    }
  }], [{
    key: "observedAttributes",
    get: function get() {
      return ["name", "theme"];
    }
  }]);

  return DlsDropdowns;
}(SvelteElement);

var select = {
  "_nativeSelect": "mc25c82f5e__nativeSelect"
};
var _nativeSelect = "mc25c82f5e__nativeSelect";
var styles$a = ".mc25c82f5e__nativeSelect{display:none}[data-style]{display:none}";
var selectStyles =
/*#__PURE__*/
Object.freeze({
  __proto__: null,
  'default': select,
  _nativeSelect: _nativeSelect,
  styles: styles$a
});

function create_fragment$8(ctx) {
  var div0;
  var t0;
  var dls_dropdown;
  var dls_dropdown_trigger;
  var t1;
  var dls_list;
  var span;
  var initialize_action;
  var t3;
  var div1;
  var slot2;
  var div1_class_value;
  var dispose;
  return {
    c: function c() {
      div0 = element("div");
      t0 = space();
      dls_dropdown = element("dls-dropdown");
      dls_dropdown_trigger = element("dls-dropdown-trigger");
      t1 = space();
      dls_list = element("dls-list");
      span = element("span");
      span.innerHTML = "<slot name=\"select-item\" slot=\"list-item\"></slot> \n      <slot slot=\"list-item\"></slot>";
      t3 = space();
      div1 = element("div");
      slot2 = element("slot");
      this.c = noop;
      attr(div0, "data-style", "");
      set_custom_element_data(dls_dropdown_trigger, "color",
      /*color*/
      ctx[2]);
      set_custom_element_data(dls_dropdown_trigger, "disabled",
      /*disabled*/
      ctx[3]);
      set_custom_element_data(dls_dropdown_trigger, "label",
      /*label*/
      ctx[4]);
      set_custom_element_data(dls_dropdown_trigger, "open",
      /*open*/
      ctx[0]);
      set_custom_element_data(dls_dropdown_trigger, "placeholder",
      /*placeholder*/
      ctx[7]);
      set_custom_element_data(dls_dropdown_trigger, "slot", "dropdown-trigger");
      set_custom_element_data(dls_dropdown_trigger, "theme",
      /*theme*/
      ctx[9]);
      set_custom_element_data(dls_dropdown_trigger, "type",
      /*type*/
      ctx[11]);
      set_custom_element_data(dls_list, "multiple",
      /*multiple*/
      ctx[5]);
      set_custom_element_data(dls_list, "theme",
      /*theme*/
      ctx[9]);
      set_custom_element_data(dls_list, "toggleable",
      /*toggleable*/
      ctx[10]);
      set_custom_element_data(dls_list, "slot", "dropdown-menu");
      set_custom_element_data(dls_dropdown, "data-hook", "dls-select");
      set_custom_element_data(dls_dropdown, "align",
      /*align*/
      ctx[1]);
      set_custom_element_data(dls_dropdown, "disabled",
      /*disabled*/
      ctx[3]);
      set_custom_element_data(dls_dropdown, "noscroll",
      /*noscroll*/
      ctx[6]);
      set_custom_element_data(dls_dropdown, "open",
      /*open*/
      ctx[0]);
      set_custom_element_data(dls_dropdown, "position",
      /*position*/
      ctx[8]);
      set_custom_element_data(dls_dropdown, "theme",
      /*theme*/
      ctx[9]);
      set_custom_element_data(dls_dropdown, "wrapmenu",
      /*wrapmenu*/
      ctx[12]);
      set_custom_element_data(dls_dropdown, "autoclose", "autoclose");
      attr(slot2, "name", "select-control");
      attr(div1, "class", div1_class_value =
      /*style*/
      ctx[16].is("_nativeSelect"));
    },
    m: function m(target, anchor) {
      insert(target, div0, anchor);
      div0.innerHTML =
      /*stylesheet*/
      ctx[15];
      insert(target, t0, anchor);
      insert(target, dls_dropdown, anchor);
      append(dls_dropdown, dls_dropdown_trigger);
      append(dls_dropdown, t1);
      append(dls_dropdown, dls_list);
      append(dls_list, span);
      /*dls_list_binding*/

      ctx[27](dls_list);
      insert(target, t3, anchor);
      insert(target, div1, anchor);
      append(div1, slot2);
      /*slot2_binding*/

      ctx[28](slot2);
      dispose = action_destroyer(initialize_action =
      /*initialize*/
      ctx[17].call(null, dls_dropdown));
    },
    p: function p(ctx, _ref) {
      var _ref2 = _slicedToArray(_ref, 1),
          dirty = _ref2[0];

      if (dirty &
      /*color*/
      4) {
        set_custom_element_data(dls_dropdown_trigger, "color",
        /*color*/
        ctx[2]);
      }

      if (dirty &
      /*disabled*/
      8) {
        set_custom_element_data(dls_dropdown_trigger, "disabled",
        /*disabled*/
        ctx[3]);
      }

      if (dirty &
      /*label*/
      16) {
        set_custom_element_data(dls_dropdown_trigger, "label",
        /*label*/
        ctx[4]);
      }

      if (dirty &
      /*open*/
      1) {
        set_custom_element_data(dls_dropdown_trigger, "open",
        /*open*/
        ctx[0]);
      }

      if (dirty &
      /*placeholder*/
      128) {
        set_custom_element_data(dls_dropdown_trigger, "placeholder",
        /*placeholder*/
        ctx[7]);
      }

      if (dirty &
      /*theme*/
      512) {
        set_custom_element_data(dls_dropdown_trigger, "theme",
        /*theme*/
        ctx[9]);
      }

      if (dirty &
      /*type*/
      2048) {
        set_custom_element_data(dls_dropdown_trigger, "type",
        /*type*/
        ctx[11]);
      }

      if (dirty &
      /*multiple*/
      32) {
        set_custom_element_data(dls_list, "multiple",
        /*multiple*/
        ctx[5]);
      }

      if (dirty &
      /*theme*/
      512) {
        set_custom_element_data(dls_list, "theme",
        /*theme*/
        ctx[9]);
      }

      if (dirty &
      /*toggleable*/
      1024) {
        set_custom_element_data(dls_list, "toggleable",
        /*toggleable*/
        ctx[10]);
      }

      if (dirty &
      /*align*/
      2) {
        set_custom_element_data(dls_dropdown, "align",
        /*align*/
        ctx[1]);
      }

      if (dirty &
      /*disabled*/
      8) {
        set_custom_element_data(dls_dropdown, "disabled",
        /*disabled*/
        ctx[3]);
      }

      if (dirty &
      /*noscroll*/
      64) {
        set_custom_element_data(dls_dropdown, "noscroll",
        /*noscroll*/
        ctx[6]);
      }

      if (dirty &
      /*open*/
      1) {
        set_custom_element_data(dls_dropdown, "open",
        /*open*/
        ctx[0]);
      }

      if (dirty &
      /*position*/
      256) {
        set_custom_element_data(dls_dropdown, "position",
        /*position*/
        ctx[8]);
      }

      if (dirty &
      /*theme*/
      512) {
        set_custom_element_data(dls_dropdown, "theme",
        /*theme*/
        ctx[9]);
      }

      if (dirty &
      /*wrapmenu*/
      4096) {
        set_custom_element_data(dls_dropdown, "wrapmenu",
        /*wrapmenu*/
        ctx[12]);
      }
    },
    i: noop,
    o: noop,
    d: function d(detaching) {
      if (detaching) detach(div0);
      if (detaching) detach(t0);
      if (detaching) detach(dls_dropdown);
      /*dls_list_binding*/

      ctx[27](null);
      if (detaching) detach(t3);
      if (detaching) detach(div1);
      /*slot2_binding*/

      ctx[28](null);
      dispose();
    }
  };
}

function instance$8($$self, $$props, $$invalidate) {
  var stylesheet = "<style>".concat(styles$a, "</style>");
  var style = new StyleUtilities(selectStyles);
  var dropdownElement, hostElement, listElement, nativeSelect;

  function initialize(node) {
    dropdownElement = node;
    hostElement = node.parentNode.host;
    node.addEventListener("dlslistchange", onListChange);
    node.addEventListener("dlsdropdowntoggle", onDropDownToggle);
    return {
      destroy: function destroy() {
        node.removeEventListener("dlslistchange", onListChange);
        node.removeEventListener("dlsdropdowntoggle", onDropDownToggle);
      }
    };
  }

  function onListChange(event) {
    var _labellist = event.detail._labellist;
    var _valuelist = event.detail._valuelist;
    hostElement.setAttribute("label", normalizeLabelList(_labellist, multiple));
    hostElement.value = _valuelist;
    syncNativeSelect(_valuelist);

    if (!multiple) {
      closeMenu();
    }
  }

  function syncNativeSelect(_valuelist) {
    if (!nativeSelect) {
      return;
    }

    nativeSelect.assignedNodes().forEach(function (select) {
      var options = Array.from(select.querySelectorAll("option"));
      options.forEach(function (option) {
        if (_valuelist.indexOf(option.getAttribute("value")) !== -1) {
          option.setAttribute("selected", "selected");
        } else {
          option.removeAttribute("selected");
        }
      });
      var changeEvent = new Event("change", {
        bubbles: true
      });
      var inputEvent = new Event("input", {
        bubbles: true
      });
      var dlsChangeEvent = new CustomEvent("dlschange", {
        bubbles: true
      });
      select.dispatchEvent(changeEvent);
      select.dispatchEvent(inputEvent);
      hostElement.dispatchEvent(dlsChangeEvent);
    });
  }

  function updateValueList(value) {
    if (!dropdownElement || !listElement) {
      return;
    } // TODO: tentative support
    // May be set by attribute if a single value
    // Otherwise must be set as a property with an array
    // For full support from an attribute, would
    // need to determine or allow setting of a delimiter


    if (typeof value === "string") {
      value = [value];
    }

    dropdownElement._valuelist = value;
    $$invalidate(13, listElement._valuelist = value, listElement);
  }

  function onDropDownToggle(event) {
    $$invalidate(0, open = event.detail.open);

    if (open) {
      openMenu();
    } else {
      closeMenu();
    }
  }

  function openMenu(event) {
    hostElement.setAttribute("open", "open");
  }

  function closeMenu(event) {
    hostElement.removeAttribute("open");
  }

  var _$$props$align = $$props.align,
      align = _$$props$align === void 0 ? "bottom" : _$$props$align;
  var _$$props$color = $$props.color,
      color = _$$props$color === void 0 ? "black" : _$$props$color;
  var _$$props$disabled = $$props.disabled,
      disabled = _$$props$disabled === void 0 ? false : _$$props$disabled;
  var _$$props$label = $$props.label,
      label = _$$props$label === void 0 ? "" : _$$props$label;
  var _$$props$multiple = $$props.multiple,
      multiple = _$$props$multiple === void 0 ? false : _$$props$multiple;
  var _$$props$noscroll = $$props.noscroll,
      noscroll = _$$props$noscroll === void 0 ? false : _$$props$noscroll;
  var _$$props$open = $$props.open,
      open = _$$props$open === void 0 ? false : _$$props$open;
  var _$$props$placeholder = $$props.placeholder,
      placeholder = _$$props$placeholder === void 0 ? "" : _$$props$placeholder;
  var _$$props$position = $$props.position,
      position = _$$props$position === void 0 ? "left" : _$$props$position;
  var _$$props$theme = $$props.theme,
      theme = _$$props$theme === void 0 ? "field" : _$$props$theme;
  var _$$props$toggleable = $$props.toggleable,
      toggleable = _$$props$toggleable === void 0 ? false : _$$props$toggleable;
  var _$$props$type = $$props.type,
      type = _$$props$type === void 0 ? "select" : _$$props$type;
  var _$$props$value = $$props.value,
      value = _$$props$value === void 0 ? [] : _$$props$value; // TODO: not in documentation; how should this work?

  var _$$props$wrapmenu = $$props.wrapmenu,
      wrapmenu = _$$props$wrapmenu === void 0 ? false : _$$props$wrapmenu;

  function dls_list_binding($$value) {
    binding_callbacks[$$value ? "unshift" : "push"](function () {
      $$invalidate(13, listElement = $$value);
    });
  }

  function slot2_binding($$value) {
    binding_callbacks[$$value ? "unshift" : "push"](function () {
      $$invalidate(14, nativeSelect = $$value);
    });
  }

  $$self.$set = function ($$props) {
    if ("align" in $$props) $$invalidate(1, align = $$props.align);
    if ("color" in $$props) $$invalidate(2, color = $$props.color);
    if ("disabled" in $$props) $$invalidate(3, disabled = $$props.disabled);
    if ("label" in $$props) $$invalidate(4, label = $$props.label);
    if ("multiple" in $$props) $$invalidate(5, multiple = $$props.multiple);
    if ("noscroll" in $$props) $$invalidate(6, noscroll = $$props.noscroll);
    if ("open" in $$props) $$invalidate(0, open = $$props.open);
    if ("placeholder" in $$props) $$invalidate(7, placeholder = $$props.placeholder);
    if ("position" in $$props) $$invalidate(8, position = $$props.position);
    if ("theme" in $$props) $$invalidate(9, theme = $$props.theme);
    if ("toggleable" in $$props) $$invalidate(10, toggleable = $$props.toggleable);
    if ("type" in $$props) $$invalidate(11, type = $$props.type);
    if ("value" in $$props) $$invalidate(18, value = $$props.value);
    if ("wrapmenu" in $$props) $$invalidate(12, wrapmenu = $$props.wrapmenu);
  };

  $$self.$$.update = function () {
    if ($$self.$$.dirty &
    /*value*/
    262144) {
      // instead of _valuelist="{value}": attribute vs property
      updateValueList(value);
    }
  };

  return [open, align, color, disabled, label, multiple, noscroll, placeholder, position, theme, toggleable, type, wrapmenu, listElement, nativeSelect, stylesheet, style, initialize, value, dropdownElement, hostElement, onListChange, syncNativeSelect, updateValueList, onDropDownToggle, openMenu, closeMenu, dls_list_binding, slot2_binding];
}

var DlsDropdowns$8 =
/*#__PURE__*/
function (_SvelteElement) {
  _inherits(DlsDropdowns, _SvelteElement);

  function DlsDropdowns(options) {
    var _this;

    _classCallCheck(this, DlsDropdowns);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DlsDropdowns).call(this));
    init(_assertThisInitialized(_this), {
      target: _this.shadowRoot
    }, instance$8, create_fragment$8, safe_not_equal, {
      align: 1,
      color: 2,
      disabled: 3,
      label: 4,
      multiple: 5,
      noscroll: 6,
      open: 0,
      placeholder: 7,
      position: 8,
      theme: 9,
      toggleable: 10,
      type: 11,
      value: 18,
      wrapmenu: 12
    });

    if (options) {
      if (options.target) {
        insert(options.target, _assertThisInitialized(_this), options.anchor);
      }

      if (options.props) {
        _this.$set(options.props);

        flush();
      }
    }

    return _this;
  }

  _createClass(DlsDropdowns, [{
    key: "align",
    get: function get() {
      return this.$$.ctx[1];
    },
    set: function set(align) {
      this.$set({
        align: align
      });
      flush();
    }
  }, {
    key: "color",
    get: function get() {
      return this.$$.ctx[2];
    },
    set: function set(color) {
      this.$set({
        color: color
      });
      flush();
    }
  }, {
    key: "disabled",
    get: function get() {
      return this.$$.ctx[3];
    },
    set: function set(disabled) {
      this.$set({
        disabled: disabled
      });
      flush();
    }
  }, {
    key: "label",
    get: function get() {
      return this.$$.ctx[4];
    },
    set: function set(label) {
      this.$set({
        label: label
      });
      flush();
    }
  }, {
    key: "multiple",
    get: function get() {
      return this.$$.ctx[5];
    },
    set: function set(multiple) {
      this.$set({
        multiple: multiple
      });
      flush();
    }
  }, {
    key: "noscroll",
    get: function get() {
      return this.$$.ctx[6];
    },
    set: function set(noscroll) {
      this.$set({
        noscroll: noscroll
      });
      flush();
    }
  }, {
    key: "open",
    get: function get() {
      return this.$$.ctx[0];
    },
    set: function set(open) {
      this.$set({
        open: open
      });
      flush();
    }
  }, {
    key: "placeholder",
    get: function get() {
      return this.$$.ctx[7];
    },
    set: function set(placeholder) {
      this.$set({
        placeholder: placeholder
      });
      flush();
    }
  }, {
    key: "position",
    get: function get() {
      return this.$$.ctx[8];
    },
    set: function set(position) {
      this.$set({
        position: position
      });
      flush();
    }
  }, {
    key: "theme",
    get: function get() {
      return this.$$.ctx[9];
    },
    set: function set(theme) {
      this.$set({
        theme: theme
      });
      flush();
    }
  }, {
    key: "toggleable",
    get: function get() {
      return this.$$.ctx[10];
    },
    set: function set(toggleable) {
      this.$set({
        toggleable: toggleable
      });
      flush();
    }
  }, {
    key: "type",
    get: function get() {
      return this.$$.ctx[11];
    },
    set: function set(type) {
      this.$set({
        type: type
      });
      flush();
    }
  }, {
    key: "value",
    get: function get() {
      return this.$$.ctx[18];
    },
    set: function set(value) {
      this.$set({
        value: value
      });
      flush();
    }
  }, {
    key: "wrapmenu",
    get: function get() {
      return this.$$.ctx[12];
    },
    set: function set(wrapmenu) {
      this.$set({
        wrapmenu: wrapmenu
      });
      flush();
    }
  }], [{
    key: "observedAttributes",
    get: function get() {
      return ["align", "color", "disabled", "label", "multiple", "noscroll", "open", "placeholder", "position", "theme", "toggleable", "type", "value", "wrapmenu"];
    }
  }]);

  return DlsDropdowns;
}(SvelteElement);

var elements = [{
  tagName: 'dls-dropdown',
  customElement: DlsDropdowns
}, {
  tagName: 'dls-dropdown-trigger',
  customElement: DlsDropdowns$1
}, {
  tagName: 'dls-list',
  customElement: DlsDropdowns$2
}, {
  tagName: 'dls-list-item',
  customElement: DlsDropdowns$3
}, {
  tagName: 'dls-list-item-button',
  customElement: DlsDropdowns$5
}, {
  tagName: 'dls-list-item-category',
  customElement: DlsDropdowns$7
}, {
  tagName: 'dls-list-item-divider',
  customElement: DlsDropdowns$6
}, {
  tagName: 'dls-list-item-link',
  customElement: DlsDropdowns$4
}, {
  tagName: 'dls-select',
  customElement: DlsDropdowns$8
}];
elements.forEach(function (_ref) {
  var tagName = _ref.tagName,
      customElement = _ref.customElement; // TODO: create shared utility later
  // TODO: don't call by default later, will be breaking change

  try {
    window.customElements.define(tagName, customElement);
  } catch (error) {// TODO: See https://github.com/collectivehealth/dls/issues/552
  }
});

function addStyles$2(styles) {
  var componentStyles = {
    'dls-dropdown': addStyles,
    'dls-dropdown-trigger': addStyles,
    'dls-list': addStyles$1,
    'dls-list-item': addStyles$1,
    'dls-list-item-button': addStyles$1,
    'dls-list-item-category': addStyles$1,
    'dls-list-item-divider': addStyles$1,
    'dls-list-item-link': addStyles$1
  };
  styles.forEach(function (style) {
    if (style.component && componentStyles[style.component]) {
      componentStyles[style.component](style);
    }
  });
}

export default DlsDropdowns;
export { DlsDropdowns as DlsDropdown, DlsDropdowns$1 as DlsDropdownTrigger, DlsDropdowns$2 as DlsList, DlsDropdowns$3 as DlsListItem, DlsDropdowns$5 as DlsListItemButton, DlsDropdowns$7 as DlsListItemCategory, DlsDropdowns$6 as DlsListItemDivider, DlsDropdowns$4 as DlsListItemLink, DlsDropdowns$8 as DlsSelect, addStyles as addDropdownStyles, addStyles$1 as addListStyles, addStyles$2 as addStyles };